/**
 * Google Text To Speech supported languages: https://cloud.google.com/text-to-speech/docs/list-voices-and-types#list_of_all_supported_languages
 *
 */
export enum GoogleTTSLanguage {
  'af-ZA-Standard-A' = 'Afrikaans (South Africa) (Standard-A Female)',
  'ar-XA-Chirp3-HD-Achernar' = 'Arabic (Chirp3-HD-Achernar Female)',
  'ar-XA-Chirp3-HD-Achird' = 'Arabic (Chirp3-HD-Achird Male)',
  'ar-XA-Chirp3-HD-Algenib' = 'Arabic (Chirp3-HD-Algenib Male)',
  'ar-XA-Chirp3-HD-Algieba' = 'Arabic (Chirp3-HD-Algieba Male)',
  'ar-XA-Chirp3-HD-Alnilam' = 'Arabic (Chirp3-HD-Alnilam Male)',
  'ar-XA-Chirp3-HD-Aoede' = 'Arabic (Chirp3-HD-Aoede Female)',
  'ar-XA-Chirp3-HD-Autonoe' = 'Arabic (Chirp3-HD-Autonoe Female)',
  'ar-XA-Chirp3-HD-Callirrhoe' = 'Arabic (Chirp3-HD-Callirrhoe Female)',
  'ar-XA-Chirp3-HD-Charon' = 'Arabic (Chirp3-HD-Charon Male)',
  'ar-XA-Chirp3-HD-Despina' = 'Arabic (Chirp3-HD-Despina Female)',
  'ar-XA-Chirp3-HD-Enceladus' = 'Arabic (Chirp3-HD-Enceladus Male)',
  'ar-XA-Chirp3-HD-Erinome' = 'Arabic (Chirp3-HD-Erinome Female)',
  'ar-XA-Chirp3-HD-Fenrir' = 'Arabic (Chirp3-HD-Fenrir Male)',
  'ar-XA-Chirp3-HD-Gacrux' = 'Arabic (Chirp3-HD-Gacrux Female)',
  'ar-XA-Chirp3-HD-Iapetus' = 'Arabic (Chirp3-HD-Iapetus Male)',
  'ar-XA-Chirp3-HD-Kore' = 'Arabic (Chirp3-HD-Kore Female)',
  'ar-XA-Chirp3-HD-Laomedeia' = 'Arabic (Chirp3-HD-Laomedeia Female)',
  'ar-XA-Chirp3-HD-Leda' = 'Arabic (Chirp3-HD-Leda Female)',
  'ar-XA-Chirp3-HD-Orus' = 'Arabic (Chirp3-HD-Orus Male)',
  'ar-XA-Chirp3-HD-Puck' = 'Arabic (Chirp3-HD-Puck Male)',
  'ar-XA-Chirp3-HD-Pulcherrima' = 'Arabic (Chirp3-HD-Pulcherrima Female)',
  'ar-XA-Chirp3-HD-Rasalgethi' = 'Arabic (Chirp3-HD-Rasalgethi Male)',
  'ar-XA-Chirp3-HD-Sadachbia' = 'Arabic (Chirp3-HD-Sadachbia Male)',
  'ar-XA-Chirp3-HD-Sadaltager' = 'Arabic (Chirp3-HD-Sadaltager Male)',
  'ar-XA-Chirp3-HD-Schedar' = 'Arabic (Chirp3-HD-Schedar Male)',
  'ar-XA-Chirp3-HD-Sulafat' = 'Arabic (Chirp3-HD-Sulafat Female)',
  'ar-XA-Chirp3-HD-Umbriel' = 'Arabic (Chirp3-HD-Umbriel Male)',
  'ar-XA-Chirp3-HD-Vindemiatrix' = 'Arabic (Chirp3-HD-Vindemiatrix Female)',
  'ar-XA-Chirp3-HD-Zephyr' = 'Arabic (Chirp3-HD-Zephyr Female)',
  'ar-XA-Chirp3-HD-Zubenelgenubi' = 'Arabic (Chirp3-HD-Zubenelgenubi Male)',
  'ar-XA-Standard-A' = 'Arabic (Standard-A Female)',
  'ar-XA-Standard-B' = 'Arabic (Standard-B Male)',
  'ar-XA-Standard-C' = 'Arabic (Standard-C Male)',
  'ar-XA-Standard-D' = 'Arabic (Standard-D Female)',
  'ar-XA-Wavenet-A' = 'Arabic (Wavenet-A Female)',
  'ar-XA-Wavenet-B' = 'Arabic (Wavenet-B Male)',
  'ar-XA-Wavenet-C' = 'Arabic (Wavenet-C Male)',
  'ar-XA-Wavenet-D' = 'Arabic (Wavenet-D Female)',
  'eu-ES-Standard-B' = 'Basque (Spain) (Standard-B Female)',
  'bn-IN-Chirp3-HD-Achernar' = 'Bengali (India) (Chirp3-HD-Achernar Female)',
  'bn-IN-Chirp3-HD-Achird' = 'Bengali (India) (Chirp3-HD-Achird Male)',
  'bn-IN-Chirp3-HD-Algenib' = 'Bengali (India) (Chirp3-HD-Algenib Male)',
  'bn-IN-Chirp3-HD-Algieba' = 'Bengali (India) (Chirp3-HD-Algieba Male)',
  'bn-IN-Chirp3-HD-Alnilam' = 'Bengali (India) (Chirp3-HD-Alnilam Male)',
  'bn-IN-Chirp3-HD-Aoede' = 'Bengali (India) (Chirp3-HD-Aoede Female)',
  'bn-IN-Chirp3-HD-Autonoe' = 'Bengali (India) (Chirp3-HD-Autonoe Female)',
  'bn-IN-Chirp3-HD-Callirrhoe' = 'Bengali (India) (Chirp3-HD-Callirrhoe Female)',
  'bn-IN-Chirp3-HD-Charon' = 'Bengali (India) (Chirp3-HD-Charon Male)',
  'bn-IN-Chirp3-HD-Despina' = 'Bengali (India) (Chirp3-HD-Despina Female)',
  'bn-IN-Chirp3-HD-Enceladus' = 'Bengali (India) (Chirp3-HD-Enceladus Male)',
  'bn-IN-Chirp3-HD-Erinome' = 'Bengali (India) (Chirp3-HD-Erinome Female)',
  'bn-IN-Chirp3-HD-Fenrir' = 'Bengali (India) (Chirp3-HD-Fenrir Male)',
  'bn-IN-Chirp3-HD-Gacrux' = 'Bengali (India) (Chirp3-HD-Gacrux Female)',
  'bn-IN-Chirp3-HD-Iapetus' = 'Bengali (India) (Chirp3-HD-Iapetus Male)',
  'bn-IN-Chirp3-HD-Kore' = 'Bengali (India) (Chirp3-HD-Kore Female)',
  'bn-IN-Chirp3-HD-Laomedeia' = 'Bengali (India) (Chirp3-HD-Laomedeia Female)',
  'bn-IN-Chirp3-HD-Leda' = 'Bengali (India) (Chirp3-HD-Leda Female)',
  'bn-IN-Chirp3-HD-Orus' = 'Bengali (India) (Chirp3-HD-Orus Male)',
  'bn-IN-Chirp3-HD-Puck' = 'Bengali (India) (Chirp3-HD-Puck Male)',
  'bn-IN-Chirp3-HD-Pulcherrima' = 'Bengali (India) (Chirp3-HD-Pulcherrima Female)',
  'bn-IN-Chirp3-HD-Rasalgethi' = 'Bengali (India) (Chirp3-HD-Rasalgethi Male)',
  'bn-IN-Chirp3-HD-Sadachbia' = 'Bengali (India) (Chirp3-HD-Sadachbia Male)',
  'bn-IN-Chirp3-HD-Sadaltager' = 'Bengali (India) (Chirp3-HD-Sadaltager Male)',
  'bn-IN-Chirp3-HD-Schedar' = 'Bengali (India) (Chirp3-HD-Schedar Male)',
  'bn-IN-Chirp3-HD-Sulafat' = 'Bengali (India) (Chirp3-HD-Sulafat Female)',
  'bn-IN-Chirp3-HD-Umbriel' = 'Bengali (India) (Chirp3-HD-Umbriel Male)',
  'bn-IN-Chirp3-HD-Vindemiatrix' = 'Bengali (India) (Chirp3-HD-Vindemiatrix Female)',
  'bn-IN-Chirp3-HD-Zephyr' = 'Bengali (India) (Chirp3-HD-Zephyr Female)',
  'bn-IN-Chirp3-HD-Zubenelgenubi' = 'Bengali (India) (Chirp3-HD-Zubenelgenubi Male)',
  'bn-IN-Standard-A' = 'Bengali (India) (Standard-A Female)',
  'bn-IN-Standard-B' = 'Bengali (India) (Standard-B Male)',
  'bn-IN-Standard-C' = 'Bengali (India) (Standard-C Female)',
  'bn-IN-Standard-D' = 'Bengali (India) (Standard-D Male)',
  'bn-IN-Wavenet-A' = 'Bengali (India) (Wavenet-A Female)',
  'bn-IN-Wavenet-B' = 'Bengali (India) (Wavenet-B Male)',
  'bn-IN-Wavenet-C' = 'Bengali (India) (Wavenet-C Female)',
  'bn-IN-Wavenet-D' = 'Bengali (India) (Wavenet-D Male)',
  'bg-BG-Standard-B' = 'Bulgarian (Bulgaria) (Standard-B Female)',
  'ca-ES-Standard-B' = 'Catalan (Spain) (Standard-B Female)',
  'yue-HK-Standard-A' = 'Chinese (Hong Kong) (Standard-A Female)',
  'yue-HK-Standard-B' = 'Chinese (Hong Kong) (Standard-B Male)',
  'yue-HK-Standard-C' = 'Chinese (Hong Kong) (Standard-C Female)',
  'yue-HK-Standard-D' = 'Chinese (Hong Kong) (Standard-D Male)',
  'cs-CZ-Standard-B' = 'Czech (Czech Republic) (Standard-B Female)',
  'cs-CZ-Wavenet-B' = 'Czech (Czech Republic) (Wavenet-B Female)',
  'da-DK-Neural2-F' = 'Danish (Denmark) (Neural2-F Female)',
  'da-DK-Standard-F' = 'Danish (Denmark) (Standard-F Female)',
  'da-DK-Standard-G' = 'Danish (Denmark) (Standard-G Male)',
  'da-DK-Wavenet-F' = 'Danish (Denmark) (Wavenet-F Female)',
  'da-DK-Wavenet-G' = 'Danish (Denmark) (Wavenet-G Male)',
  'nl-BE-Chirp3-HD-Achernar' = 'Dutch (Belgium) (Chirp3-HD-Achernar Female)',
  'nl-BE-Chirp3-HD-Achird' = 'Dutch (Belgium) (Chirp3-HD-Achird Male)',
  'nl-BE-Chirp3-HD-Algenib' = 'Dutch (Belgium) (Chirp3-HD-Algenib Male)',
  'nl-BE-Chirp3-HD-Algieba' = 'Dutch (Belgium) (Chirp3-HD-Algieba Male)',
  'nl-BE-Chirp3-HD-Alnilam' = 'Dutch (Belgium) (Chirp3-HD-Alnilam Male)',
  'nl-BE-Chirp3-HD-Autonoe' = 'Dutch (Belgium) (Chirp3-HD-Autonoe Female)',
  'nl-BE-Chirp3-HD-Callirrhoe' = 'Dutch (Belgium) (Chirp3-HD-Callirrhoe Female)',
  'nl-BE-Chirp3-HD-Despina' = 'Dutch (Belgium) (Chirp3-HD-Despina Female)',
  'nl-BE-Chirp3-HD-Enceladus' = 'Dutch (Belgium) (Chirp3-HD-Enceladus Male)',
  'nl-BE-Chirp3-HD-Erinome' = 'Dutch (Belgium) (Chirp3-HD-Erinome Female)',
  'nl-BE-Chirp3-HD-Gacrux' = 'Dutch (Belgium) (Chirp3-HD-Gacrux Female)',
  'nl-BE-Chirp3-HD-Iapetus' = 'Dutch (Belgium) (Chirp3-HD-Iapetus Male)',
  'nl-BE-Chirp3-HD-Laomedeia' = 'Dutch (Belgium) (Chirp3-HD-Laomedeia Female)',
  'nl-BE-Chirp3-HD-Pulcherrima' = 'Dutch (Belgium) (Chirp3-HD-Pulcherrima Female)',
  'nl-BE-Chirp3-HD-Rasalgethi' = 'Dutch (Belgium) (Chirp3-HD-Rasalgethi Male)',
  'nl-BE-Chirp3-HD-Sadachbia' = 'Dutch (Belgium) (Chirp3-HD-Sadachbia Male)',
  'nl-BE-Chirp3-HD-Sadaltager' = 'Dutch (Belgium) (Chirp3-HD-Sadaltager Male)',
  'nl-BE-Chirp3-HD-Schedar' = 'Dutch (Belgium) (Chirp3-HD-Schedar Male)',
  'nl-BE-Chirp3-HD-Sulafat' = 'Dutch (Belgium) (Chirp3-HD-Sulafat Female)',
  'nl-BE-Chirp3-HD-Umbriel' = 'Dutch (Belgium) (Chirp3-HD-Umbriel Male)',
  'nl-BE-Chirp3-HD-Vindemiatrix' = 'Dutch (Belgium) (Chirp3-HD-Vindemiatrix Female)',
  'nl-BE-Chirp3-HD-Zubenelgenubi' = 'Dutch (Belgium) (Chirp3-HD-Zubenelgenubi Male)',
  'nl-BE-Standard-C' = 'Dutch (Belgium) (Standard-C Female)',
  'nl-BE-Standard-D' = 'Dutch (Belgium) (Standard-D Male)',
  'nl-BE-Wavenet-C' = 'Dutch (Belgium) (Wavenet-C Female)',
  'nl-BE-Wavenet-D' = 'Dutch (Belgium) (Wavenet-D Male)',
  'nl-NL-Chirp3-HD-Achernar' = 'Dutch (Netherlands) (Chirp3-HD-Achernar Female)',
  'nl-NL-Chirp3-HD-Achird' = 'Dutch (Netherlands) (Chirp3-HD-Achird Male)',
  'nl-NL-Chirp3-HD-Algenib' = 'Dutch (Netherlands) (Chirp3-HD-Algenib Male)',
  'nl-NL-Chirp3-HD-Algieba' = 'Dutch (Netherlands) (Chirp3-HD-Algieba Male)',
  'nl-NL-Chirp3-HD-Alnilam' = 'Dutch (Netherlands) (Chirp3-HD-Alnilam Male)',
  'nl-NL-Chirp3-HD-Aoede' = 'Dutch (Netherlands) (Chirp3-HD-Aoede Female)',
  'nl-NL-Chirp3-HD-Autonoe' = 'Dutch (Netherlands) (Chirp3-HD-Autonoe Female)',
  'nl-NL-Chirp3-HD-Callirrhoe' = 'Dutch (Netherlands) (Chirp3-HD-Callirrhoe Female)',
  'nl-NL-Chirp3-HD-Charon' = 'Dutch (Netherlands) (Chirp3-HD-Charon Male)',
  'nl-NL-Chirp3-HD-Despina' = 'Dutch (Netherlands) (Chirp3-HD-Despina Female)',
  'nl-NL-Chirp3-HD-Enceladus' = 'Dutch (Netherlands) (Chirp3-HD-Enceladus Male)',
  'nl-NL-Chirp3-HD-Erinome' = 'Dutch (Netherlands) (Chirp3-HD-Erinome Female)',
  'nl-NL-Chirp3-HD-Fenrir' = 'Dutch (Netherlands) (Chirp3-HD-Fenrir Male)',
  'nl-NL-Chirp3-HD-Gacrux' = 'Dutch (Netherlands) (Chirp3-HD-Gacrux Female)',
  'nl-NL-Chirp3-HD-Iapetus' = 'Dutch (Netherlands) (Chirp3-HD-Iapetus Male)',
  'nl-NL-Chirp3-HD-Kore' = 'Dutch (Netherlands) (Chirp3-HD-Kore Female)',
  'nl-NL-Chirp3-HD-Laomedeia' = 'Dutch (Netherlands) (Chirp3-HD-Laomedeia Female)',
  'nl-NL-Chirp3-HD-Leda' = 'Dutch (Netherlands) (Chirp3-HD-Leda Female)',
  'nl-NL-Chirp3-HD-Orus' = 'Dutch (Netherlands) (Chirp3-HD-Orus Male)',
  'nl-NL-Chirp3-HD-Puck' = 'Dutch (Netherlands) (Chirp3-HD-Puck Male)',
  'nl-NL-Chirp3-HD-Pulcherrima' = 'Dutch (Netherlands) (Chirp3-HD-Pulcherrima Female)',
  'nl-NL-Chirp3-HD-Rasalgethi' = 'Dutch (Netherlands) (Chirp3-HD-Rasalgethi Male)',
  'nl-NL-Chirp3-HD-Sadachbia' = 'Dutch (Netherlands) (Chirp3-HD-Sadachbia Male)',
  'nl-NL-Chirp3-HD-Sadaltager' = 'Dutch (Netherlands) (Chirp3-HD-Sadaltager Male)',
  'nl-NL-Chirp3-HD-Schedar' = 'Dutch (Netherlands) (Chirp3-HD-Schedar Male)',
  'nl-NL-Chirp3-HD-Sulafat' = 'Dutch (Netherlands) (Chirp3-HD-Sulafat Female)',
  'nl-NL-Chirp3-HD-Umbriel' = 'Dutch (Netherlands) (Chirp3-HD-Umbriel Male)',
  'nl-NL-Chirp3-HD-Vindemiatrix' = 'Dutch (Netherlands) (Chirp3-HD-Vindemiatrix Female)',
  'nl-NL-Chirp3-HD-Zephyr' = 'Dutch (Netherlands) (Chirp3-HD-Zephyr Female)',
  'nl-NL-Chirp3-HD-Zubenelgenubi' = 'Dutch (Netherlands) (Chirp3-HD-Zubenelgenubi Male)',
  'nl-NL-Standard-F' = 'Dutch (Netherlands) (Standard-F Female)',
  'nl-NL-Standard-G' = 'Dutch (Netherlands) (Standard-G Male)',
  'nl-NL-Wavenet-F' = 'Dutch (Netherlands) (Wavenet-F Female)',
  'nl-NL-Wavenet-G' = 'Dutch (Netherlands) (Wavenet-G Male)',
  'en-AU-Chirp-HD-D' = 'English (Australia) (Chirp-HD-D Male)',
  'en-AU-Chirp-HD-F' = 'English (Australia) (Chirp-HD-F Female)',
  'en-AU-Chirp-HD-O' = 'English (Australia) (Chirp-HD-O Female)',
  'en-AU-Chirp3-HD-Achernar' = 'English (Australia) (Chirp3-HD-Achernar Female)',
  'en-AU-Chirp3-HD-Achird' = 'English (Australia) (Chirp3-HD-Achird Male)',
  'en-AU-Chirp3-HD-Algenib' = 'English (Australia) (Chirp3-HD-Algenib Male)',
  'en-AU-Chirp3-HD-Algieba' = 'English (Australia) (Chirp3-HD-Algieba Male)',
  'en-AU-Chirp3-HD-Alnilam' = 'English (Australia) (Chirp3-HD-Alnilam Male)',
  'en-AU-Chirp3-HD-Aoede' = 'English (Australia) (Chirp3-HD-Aoede Female)',
  'en-AU-Chirp3-HD-Autonoe' = 'English (Australia) (Chirp3-HD-Autonoe Female)',
  'en-AU-Chirp3-HD-Callirrhoe' = 'English (Australia) (Chirp3-HD-Callirrhoe Female)',
  'en-AU-Chirp3-HD-Charon' = 'English (Australia) (Chirp3-HD-Charon Male)',
  'en-AU-Chirp3-HD-Despina' = 'English (Australia) (Chirp3-HD-Despina Female)',
  'en-AU-Chirp3-HD-Enceladus' = 'English (Australia) (Chirp3-HD-Enceladus Male)',
  'en-AU-Chirp3-HD-Erinome' = 'English (Australia) (Chirp3-HD-Erinome Female)',
  'en-AU-Chirp3-HD-Fenrir' = 'English (Australia) (Chirp3-HD-Fenrir Male)',
  'en-AU-Chirp3-HD-Gacrux' = 'English (Australia) (Chirp3-HD-Gacrux Female)',
  'en-AU-Chirp3-HD-Iapetus' = 'English (Australia) (Chirp3-HD-Iapetus Male)',
  'en-AU-Chirp3-HD-Kore' = 'English (Australia) (Chirp3-HD-Kore Female)',
  'en-AU-Chirp3-HD-Laomedeia' = 'English (Australia) (Chirp3-HD-Laomedeia Female)',
  'en-AU-Chirp3-HD-Leda' = 'English (Australia) (Chirp3-HD-Leda Female)',
  'en-AU-Chirp3-HD-Orus' = 'English (Australia) (Chirp3-HD-Orus Male)',
  'en-AU-Chirp3-HD-Puck' = 'English (Australia) (Chirp3-HD-Puck Male)',
  'en-AU-Chirp3-HD-Pulcherrima' = 'English (Australia) (Chirp3-HD-Pulcherrima Female)',
  'en-AU-Chirp3-HD-Rasalgethi' = 'English (Australia) (Chirp3-HD-Rasalgethi Male)',
  'en-AU-Chirp3-HD-Sadachbia' = 'English (Australia) (Chirp3-HD-Sadachbia Male)',
  'en-AU-Chirp3-HD-Sadaltager' = 'English (Australia) (Chirp3-HD-Sadaltager Male)',
  'en-AU-Chirp3-HD-Schedar' = 'English (Australia) (Chirp3-HD-Schedar Male)',
  'en-AU-Chirp3-HD-Sulafat' = 'English (Australia) (Chirp3-HD-Sulafat Female)',
  'en-AU-Chirp3-HD-Umbriel' = 'English (Australia) (Chirp3-HD-Umbriel Male)',
  'en-AU-Chirp3-HD-Vindemiatrix' = 'English (Australia) (Chirp3-HD-Vindemiatrix Female)',
  'en-AU-Chirp3-HD-Zephyr' = 'English (Australia) (Chirp3-HD-Zephyr Female)',
  'en-AU-Chirp3-HD-Zubenelgenubi' = 'English (Australia) (Chirp3-HD-Zubenelgenubi Male)',
  'en-AU-Neural2-A' = 'English (Australia) (Neural2-A Female)',
  'en-AU-Neural2-B' = 'English (Australia) (Neural2-B Male)',
  'en-AU-Neural2-C' = 'English (Australia) (Neural2-C Female)',
  'en-AU-Neural2-D' = 'English (Australia) (Neural2-D Male)',
  'en-AU-News-E' = 'English (Australia) (News-E Female)',
  'en-AU-News-F' = 'English (Australia) (News-F Female)',
  'en-AU-News-G' = 'English (Australia) (News-G Male)',
  'en-AU-Polyglot-1' = 'English (Australia) (Polyglot-1 Male)',
  'en-AU-Standard-A' = 'English (Australia) (Standard-A Female)',
  'en-AU-Standard-B' = 'English (Australia) (Standard-B Male)',
  'en-AU-Standard-C' = 'English (Australia) (Standard-C Female)',
  'en-AU-Standard-D' = 'English (Australia) (Standard-D Male)',
  'en-AU-Wavenet-A' = 'English (Australia) (Wavenet-A Female)',
  'en-AU-Wavenet-B' = 'English (Australia) (Wavenet-B Male)',
  'en-AU-Wavenet-C' = 'English (Australia) (Wavenet-C Female)',
  'en-AU-Wavenet-D' = 'English (Australia) (Wavenet-D Male)',
  'en-IN-Chirp-HD-D' = 'English (India) (Chirp-HD-D Male)',
  'en-IN-Chirp-HD-F' = 'English (India) (Chirp-HD-F Female)',
  'en-IN-Chirp-HD-O' = 'English (India) (Chirp-HD-O Female)',
  'en-IN-Chirp3-HD-Achernar' = 'English (India) (Chirp3-HD-Achernar Female)',
  'en-IN-Chirp3-HD-Achird' = 'English (India) (Chirp3-HD-Achird Male)',
  'en-IN-Chirp3-HD-Algenib' = 'English (India) (Chirp3-HD-Algenib Male)',
  'en-IN-Chirp3-HD-Algieba' = 'English (India) (Chirp3-HD-Algieba Male)',
  'en-IN-Chirp3-HD-Alnilam' = 'English (India) (Chirp3-HD-Alnilam Male)',
  'en-IN-Chirp3-HD-Aoede' = 'English (India) (Chirp3-HD-Aoede Female)',
  'en-IN-Chirp3-HD-Autonoe' = 'English (India) (Chirp3-HD-Autonoe Female)',
  'en-IN-Chirp3-HD-Callirrhoe' = 'English (India) (Chirp3-HD-Callirrhoe Female)',
  'en-IN-Chirp3-HD-Charon' = 'English (India) (Chirp3-HD-Charon Male)',
  'en-IN-Chirp3-HD-Despina' = 'English (India) (Chirp3-HD-Despina Female)',
  'en-IN-Chirp3-HD-Enceladus' = 'English (India) (Chirp3-HD-Enceladus Male)',
  'en-IN-Chirp3-HD-Erinome' = 'English (India) (Chirp3-HD-Erinome Female)',
  'en-IN-Chirp3-HD-Fenrir' = 'English (India) (Chirp3-HD-Fenrir Male)',
  'en-IN-Chirp3-HD-Gacrux' = 'English (India) (Chirp3-HD-Gacrux Female)',
  'en-IN-Chirp3-HD-Iapetus' = 'English (India) (Chirp3-HD-Iapetus Male)',
  'en-IN-Chirp3-HD-Kore' = 'English (India) (Chirp3-HD-Kore Female)',
  'en-IN-Chirp3-HD-Laomedeia' = 'English (India) (Chirp3-HD-Laomedeia Female)',
  'en-IN-Chirp3-HD-Leda' = 'English (India) (Chirp3-HD-Leda Female)',
  'en-IN-Chirp3-HD-Orus' = 'English (India) (Chirp3-HD-Orus Male)',
  'en-IN-Chirp3-HD-Puck' = 'English (India) (Chirp3-HD-Puck Male)',
  'en-IN-Chirp3-HD-Pulcherrima' = 'English (India) (Chirp3-HD-Pulcherrima Female)',
  'en-IN-Chirp3-HD-Rasalgethi' = 'English (India) (Chirp3-HD-Rasalgethi Male)',
  'en-IN-Chirp3-HD-Sadachbia' = 'English (India) (Chirp3-HD-Sadachbia Male)',
  'en-IN-Chirp3-HD-Sadaltager' = 'English (India) (Chirp3-HD-Sadaltager Male)',
  'en-IN-Chirp3-HD-Schedar' = 'English (India) (Chirp3-HD-Schedar Male)',
  'en-IN-Chirp3-HD-Sulafat' = 'English (India) (Chirp3-HD-Sulafat Female)',
  'en-IN-Chirp3-HD-Umbriel' = 'English (India) (Chirp3-HD-Umbriel Male)',
  'en-IN-Chirp3-HD-Vindemiatrix' = 'English (India) (Chirp3-HD-Vindemiatrix Female)',
  'en-IN-Chirp3-HD-Zephyr' = 'English (India) (Chirp3-HD-Zephyr Female)',
  'en-IN-Chirp3-HD-Zubenelgenubi' = 'English (India) (Chirp3-HD-Zubenelgenubi Male)',
  'en-IN-Neural2-A' = 'English (India) (Neural2-A Female)',
  'en-IN-Neural2-B' = 'English (India) (Neural2-B Male)',
  'en-IN-Neural2-C' = 'English (India) (Neural2-C Male)',
  'en-IN-Neural2-D' = 'English (India) (Neural2-D Female)',
  'en-IN-Standard-A' = 'English (India) (Standard-A Female)',
  'en-IN-Standard-B' = 'English (India) (Standard-B Male)',
  'en-IN-Standard-C' = 'English (India) (Standard-C Male)',
  'en-IN-Standard-D' = 'English (India) (Standard-D Female)',
  'en-IN-Standard-E' = 'English (India) (Standard-E Female)',
  'en-IN-Standard-F' = 'English (India) (Standard-F Male)',
  'en-IN-Wavenet-A' = 'English (India) (Wavenet-A Female)',
  'en-IN-Wavenet-B' = 'English (India) (Wavenet-B Male)',
  'en-IN-Wavenet-C' = 'English (India) (Wavenet-C Male)',
  'en-IN-Wavenet-D' = 'English (India) (Wavenet-D Female)',
  'en-IN-Wavenet-E' = 'English (India) (Wavenet-E Female)',
  'en-IN-Wavenet-F' = 'English (India) (Wavenet-F Male)',
  'en-GB-Chirp-HD-D' = 'English (UK) (Chirp-HD-D Male)',
  'en-GB-Chirp-HD-F' = 'English (UK) (Chirp-HD-F Female)',
  'en-GB-Chirp-HD-O' = 'English (UK) (Chirp-HD-O Female)',
  'en-GB-Chirp3-HD-Achernar' = 'English (UK) (Chirp3-HD-Achernar Female)',
  'en-GB-Chirp3-HD-Achird' = 'English (UK) (Chirp3-HD-Achird Male)',
  'en-GB-Chirp3-HD-Algenib' = 'English (UK) (Chirp3-HD-Algenib Male)',
  'en-GB-Chirp3-HD-Algieba' = 'English (UK) (Chirp3-HD-Algieba Male)',
  'en-GB-Chirp3-HD-Alnilam' = 'English (UK) (Chirp3-HD-Alnilam Male)',
  'en-GB-Chirp3-HD-Aoede' = 'English (UK) (Chirp3-HD-Aoede Female)',
  'en-GB-Chirp3-HD-Autonoe' = 'English (UK) (Chirp3-HD-Autonoe Female)',
  'en-GB-Chirp3-HD-Callirrhoe' = 'English (UK) (Chirp3-HD-Callirrhoe Female)',
  'en-GB-Chirp3-HD-Charon' = 'English (UK) (Chirp3-HD-Charon Male)',
  'en-GB-Chirp3-HD-Despina' = 'English (UK) (Chirp3-HD-Despina Female)',
  'en-GB-Chirp3-HD-Enceladus' = 'English (UK) (Chirp3-HD-Enceladus Male)',
  'en-GB-Chirp3-HD-Erinome' = 'English (UK) (Chirp3-HD-Erinome Female)',
  'en-GB-Chirp3-HD-Fenrir' = 'English (UK) (Chirp3-HD-Fenrir Male)',
  'en-GB-Chirp3-HD-Gacrux' = 'English (UK) (Chirp3-HD-Gacrux Female)',
  'en-GB-Chirp3-HD-Iapetus' = 'English (UK) (Chirp3-HD-Iapetus Male)',
  'en-GB-Chirp3-HD-Kore' = 'English (UK) (Chirp3-HD-Kore Female)',
  'en-GB-Chirp3-HD-Laomedeia' = 'English (UK) (Chirp3-HD-Laomedeia Female)',
  'en-GB-Chirp3-HD-Leda' = 'English (UK) (Chirp3-HD-Leda Female)',
  'en-GB-Chirp3-HD-Orus' = 'English (UK) (Chirp3-HD-Orus Male)',
  'en-GB-Chirp3-HD-Puck' = 'English (UK) (Chirp3-HD-Puck Male)',
  'en-GB-Chirp3-HD-Pulcherrima' = 'English (UK) (Chirp3-HD-Pulcherrima Female)',
  'en-GB-Chirp3-HD-Rasalgethi' = 'English (UK) (Chirp3-HD-Rasalgethi Male)',
  'en-GB-Chirp3-HD-Sadachbia' = 'English (UK) (Chirp3-HD-Sadachbia Male)',
  'en-GB-Chirp3-HD-Sadaltager' = 'English (UK) (Chirp3-HD-Sadaltager Male)',
  'en-GB-Chirp3-HD-Schedar' = 'English (UK) (Chirp3-HD-Schedar Male)',
  'en-GB-Chirp3-HD-Sulafat' = 'English (UK) (Chirp3-HD-Sulafat Female)',
  'en-GB-Chirp3-HD-Umbriel' = 'English (UK) (Chirp3-HD-Umbriel Male)',
  'en-GB-Chirp3-HD-Vindemiatrix' = 'English (UK) (Chirp3-HD-Vindemiatrix Female)',
  'en-GB-Chirp3-HD-Zephyr' = 'English (UK) (Chirp3-HD-Zephyr Female)',
  'en-GB-Chirp3-HD-Zubenelgenubi' = 'English (UK) (Chirp3-HD-Zubenelgenubi Male)',
  'en-GB-Neural2-A' = 'English (UK) (Neural2-A Female)',
  'en-GB-Neural2-B' = 'English (UK) (Neural2-B Male)',
  'en-GB-Neural2-C' = 'English (UK) (Neural2-C Female)',
  'en-GB-Neural2-D' = 'English (UK) (Neural2-D Male)',
  'en-GB-Neural2-F' = 'English (UK) (Neural2-F Female)',
  'en-GB-Neural2-N' = 'English (UK) (Neural2-N Female)',
  'en-GB-Neural2-O' = 'English (UK) (Neural2-O Male)',
  'en-GB-News-G' = 'English (UK) (News-G Female)',
  'en-GB-News-H' = 'English (UK) (News-H Female)',
  'en-GB-News-I' = 'English (UK) (News-I Female)',
  'en-GB-News-J' = 'English (UK) (News-J Male)',
  'en-GB-News-K' = 'English (UK) (News-K Male)',
  'en-GB-News-L' = 'English (UK) (News-L Male)',
  'en-GB-News-M' = 'English (UK) (News-M Male)',
  'en-GB-Standard-A' = 'English (UK) (Standard-A Female)',
  'en-GB-Standard-B' = 'English (UK) (Standard-B Male)',
  'en-GB-Standard-C' = 'English (UK) (Standard-C Female)',
  'en-GB-Standard-D' = 'English (UK) (Standard-D Male)',
  'en-GB-Standard-F' = 'English (UK) (Standard-F Female)',
  'en-GB-Standard-N' = 'English (UK) (Standard-N Female)',
  'en-GB-Standard-O' = 'English (UK) (Standard-O Male)',
  'en-GB-Studio-B' = 'English (UK) (Studio-B Male)',
  'en-GB-Studio-C' = 'English (UK) (Studio-C Female)',
  'en-GB-Wavenet-A' = 'English (UK) (Wavenet-A Female)',
  'en-GB-Wavenet-B' = 'English (UK) (Wavenet-B Male)',
  'en-GB-Wavenet-C' = 'English (UK) (Wavenet-C Female)',
  'en-GB-Wavenet-D' = 'English (UK) (Wavenet-D Male)',
  'en-GB-Wavenet-F' = 'English (UK) (Wavenet-F Female)',
  'en-GB-Wavenet-N' = 'English (UK) (Wavenet-N Female)',
  'en-GB-Wavenet-O' = 'English (UK) (Wavenet-O Male)',
  'en-US-Casual-K' = 'English (US) (Casual-K Male)',
  'en-US-Chirp-HD-D' = 'English (US) (Chirp-HD-D Male)',
  'en-US-Chirp-HD-F' = 'English (US) (Chirp-HD-F Female)',
  'en-US-Chirp-HD-O' = 'English (US) (Chirp-HD-O Female)',
  'en-US-Chirp3-HD-Achernar' = 'English (US) (Chirp3-HD-Achernar Female)',
  'en-US-Chirp3-HD-Achird' = 'English (US) (Chirp3-HD-Achird Male)',
  'en-US-Chirp3-HD-Algenib' = 'English (US) (Chirp3-HD-Algenib Male)',
  'en-US-Chirp3-HD-Algieba' = 'English (US) (Chirp3-HD-Algieba Male)',
  'en-US-Chirp3-HD-Alnilam' = 'English (US) (Chirp3-HD-Alnilam Male)',
  'en-US-Chirp3-HD-Aoede' = 'English (US) (Chirp3-HD-Aoede Female)',
  'en-US-Chirp3-HD-Autonoe' = 'English (US) (Chirp3-HD-Autonoe Female)',
  'en-US-Chirp3-HD-Callirrhoe' = 'English (US) (Chirp3-HD-Callirrhoe Female)',
  'en-US-Chirp3-HD-Charon' = 'English (US) (Chirp3-HD-Charon Male)',
  'en-US-Chirp3-HD-Despina' = 'English (US) (Chirp3-HD-Despina Female)',
  'en-US-Chirp3-HD-Enceladus' = 'English (US) (Chirp3-HD-Enceladus Male)',
  'en-US-Chirp3-HD-Erinome' = 'English (US) (Chirp3-HD-Erinome Female)',
  'en-US-Chirp3-HD-Fenrir' = 'English (US) (Chirp3-HD-Fenrir Male)',
  'en-US-Chirp3-HD-Gacrux' = 'English (US) (Chirp3-HD-Gacrux Female)',
  'en-US-Chirp3-HD-Iapetus' = 'English (US) (Chirp3-HD-Iapetus Male)',
  'en-US-Chirp3-HD-Kore' = 'English (US) (Chirp3-HD-Kore Female)',
  'en-US-Chirp3-HD-Laomedeia' = 'English (US) (Chirp3-HD-Laomedeia Female)',
  'en-US-Chirp3-HD-Leda' = 'English (US) (Chirp3-HD-Leda Female)',
  'en-US-Chirp3-HD-Orus' = 'English (US) (Chirp3-HD-Orus Male)',
  'en-US-Chirp3-HD-Puck' = 'English (US) (Chirp3-HD-Puck Male)',
  'en-US-Chirp3-HD-Pulcherrima' = 'English (US) (Chirp3-HD-Pulcherrima Female)',
  'en-US-Chirp3-HD-Rasalgethi' = 'English (US) (Chirp3-HD-Rasalgethi Male)',
  'en-US-Chirp3-HD-Sadachbia' = 'English (US) (Chirp3-HD-Sadachbia Male)',
  'en-US-Chirp3-HD-Sadaltager' = 'English (US) (Chirp3-HD-Sadaltager Male)',
  'en-US-Chirp3-HD-Schedar' = 'English (US) (Chirp3-HD-Schedar Male)',
  'en-US-Chirp3-HD-Sulafat' = 'English (US) (Chirp3-HD-Sulafat Female)',
  'en-US-Chirp3-HD-Umbriel' = 'English (US) (Chirp3-HD-Umbriel Male)',
  'en-US-Chirp3-HD-Vindemiatrix' = 'English (US) (Chirp3-HD-Vindemiatrix Female)',
  'en-US-Chirp3-HD-Zephyr' = 'English (US) (Chirp3-HD-Zephyr Female)',
  'en-US-Chirp3-HD-Zubenelgenubi' = 'English (US) (Chirp3-HD-Zubenelgenubi Male)',
  'en-US-Neural2-A' = 'English (US) (Neural2-A Male)',
  'en-US-Neural2-C' = 'English (US) (Neural2-C Female)',
  'en-US-Neural2-D' = 'English (US) (Neural2-D Male)',
  'en-US-Neural2-E' = 'English (US) (Neural2-E Female)',
  'en-US-Neural2-F' = 'English (US) (Neural2-F Female)',
  'en-US-Neural2-G' = 'English (US) (Neural2-G Female)',
  'en-US-Neural2-H' = 'English (US) (Neural2-H Female)',
  'en-US-Neural2-I' = 'English (US) (Neural2-I Male)',
  'en-US-Neural2-J' = 'English (US) (Neural2-J Male)',
  'en-US-News-K' = 'English (US) (News-K Female)',
  'en-US-News-L' = 'English (US) (News-L Female)',
  'en-US-News-N' = 'English (US) (News-N Male)',
  'en-US-Polyglot-1' = 'English (US) (Polyglot-1 Male)',
  'en-US-Standard-A' = 'English (US) (Standard-A Male)',
  'en-US-Standard-B' = 'English (US) (Standard-B Male)',
  'en-US-Standard-C' = 'English (US) (Standard-C Female)',
  'en-US-Standard-D' = 'English (US) (Standard-D Male)',
  'en-US-Standard-E' = 'English (US) (Standard-E Female)',
  'en-US-Standard-F' = 'English (US) (Standard-F Female)',
  'en-US-Standard-G' = 'English (US) (Standard-G Female)',
  'en-US-Standard-H' = 'English (US) (Standard-H Female)',
  'en-US-Standard-I' = 'English (US) (Standard-I Male)',
  'en-US-Standard-J' = 'English (US) (Standard-J Male)',
  'en-US-Studio-O' = 'English (US) (Studio-O Female)',
  'en-US-Studio-Q' = 'English (US) (Studio-Q Male)',
  'en-US-Wavenet-A' = 'English (US) (Wavenet-A Male)',
  'en-US-Wavenet-B' = 'English (US) (Wavenet-B Male)',
  'en-US-Wavenet-C' = 'English (US) (Wavenet-C Female)',
  'en-US-Wavenet-D' = 'English (US) (Wavenet-D Male)',
  'en-US-Wavenet-E' = 'English (US) (Wavenet-E Female)',
  'en-US-Wavenet-F' = 'English (US) (Wavenet-F Female)',
  'en-US-Wavenet-G' = 'English (US) (Wavenet-G Female)',
  'en-US-Wavenet-H' = 'English (US) (Wavenet-H Female)',
  'en-US-Wavenet-I' = 'English (US) (Wavenet-I Male)',
  'en-US-Wavenet-J' = 'English (US) (Wavenet-J Male)',
  'fil-PH-Standard-A' = 'Filipino (Philippines) (Standard-A Female)',
  'fil-PH-Standard-B' = 'Filipino (Philippines) (Standard-B Female)',
  'fil-PH-Standard-C' = 'Filipino (Philippines) (Standard-C Male)',
  'fil-PH-Standard-D' = 'Filipino (Philippines) (Standard-D Male)',
  'fil-PH-Wavenet-A' = 'Filipino (Philippines) (Wavenet-A Female)',
  'fil-PH-Wavenet-B' = 'Filipino (Philippines) (Wavenet-B Female)',
  'fil-PH-Wavenet-C' = 'Filipino (Philippines) (Wavenet-C Male)',
  'fil-PH-Wavenet-D' = 'Filipino (Philippines) (Wavenet-D Male)',
  'fil-ph-Neural2-A' = 'Filipino (Philippines) (Neural2-A Female)',
  'fil-ph-Neural2-D' = 'Filipino (Philippines) (Neural2-D Male)',
  'fi-FI-Standard-B' = 'Finnish (Finland) (Standard-B Female)',
  'fi-FI-Wavenet-B' = 'Finnish (Finland) (Wavenet-B Female)',
  'fr-CA-Chirp-HD-D' = 'French (Canada) (Chirp-HD-D Male)',
  'fr-CA-Chirp-HD-F' = 'French (Canada) (Chirp-HD-F Female)',
  'fr-CA-Chirp-HD-O' = 'French (Canada) (Chirp-HD-O Female)',
  'fr-CA-Chirp3-HD-Achernar' = 'French (Canada) (Chirp3-HD-Achernar Female)',
  'fr-CA-Chirp3-HD-Achird' = 'French (Canada) (Chirp3-HD-Achird Male)',
  'fr-CA-Chirp3-HD-Algenib' = 'French (Canada) (Chirp3-HD-Algenib Male)',
  'fr-CA-Chirp3-HD-Algieba' = 'French (Canada) (Chirp3-HD-Algieba Male)',
  'fr-CA-Chirp3-HD-Alnilam' = 'French (Canada) (Chirp3-HD-Alnilam Male)',
  'fr-CA-Chirp3-HD-Aoede' = 'French (Canada) (Chirp3-HD-Aoede Female)',
  'fr-CA-Chirp3-HD-Autonoe' = 'French (Canada) (Chirp3-HD-Autonoe Female)',
  'fr-CA-Chirp3-HD-Callirrhoe' = 'French (Canada) (Chirp3-HD-Callirrhoe Female)',
  'fr-CA-Chirp3-HD-Charon' = 'French (Canada) (Chirp3-HD-Charon Male)',
  'fr-CA-Chirp3-HD-Despina' = 'French (Canada) (Chirp3-HD-Despina Female)',
  'fr-CA-Chirp3-HD-Enceladus' = 'French (Canada) (Chirp3-HD-Enceladus Male)',
  'fr-CA-Chirp3-HD-Erinome' = 'French (Canada) (Chirp3-HD-Erinome Female)',
  'fr-CA-Chirp3-HD-Fenrir' = 'French (Canada) (Chirp3-HD-Fenrir Male)',
  'fr-CA-Chirp3-HD-Gacrux' = 'French (Canada) (Chirp3-HD-Gacrux Female)',
  'fr-CA-Chirp3-HD-Iapetus' = 'French (Canada) (Chirp3-HD-Iapetus Male)',
  'fr-CA-Chirp3-HD-Kore' = 'French (Canada) (Chirp3-HD-Kore Female)',
  'fr-CA-Chirp3-HD-Laomedeia' = 'French (Canada) (Chirp3-HD-Laomedeia Female)',
  'fr-CA-Chirp3-HD-Leda' = 'French (Canada) (Chirp3-HD-Leda Female)',
  'fr-CA-Chirp3-HD-Orus' = 'French (Canada) (Chirp3-HD-Orus Male)',
  'fr-CA-Chirp3-HD-Puck' = 'French (Canada) (Chirp3-HD-Puck Male)',
  'fr-CA-Chirp3-HD-Pulcherrima' = 'French (Canada) (Chirp3-HD-Pulcherrima Female)',
  'fr-CA-Chirp3-HD-Rasalgethi' = 'French (Canada) (Chirp3-HD-Rasalgethi Male)',
  'fr-CA-Chirp3-HD-Sadachbia' = 'French (Canada) (Chirp3-HD-Sadachbia Male)',
  'fr-CA-Chirp3-HD-Sadaltager' = 'French (Canada) (Chirp3-HD-Sadaltager Male)',
  'fr-CA-Chirp3-HD-Schedar' = 'French (Canada) (Chirp3-HD-Schedar Male)',
  'fr-CA-Chirp3-HD-Sulafat' = 'French (Canada) (Chirp3-HD-Sulafat Female)',
  'fr-CA-Chirp3-HD-Umbriel' = 'French (Canada) (Chirp3-HD-Umbriel Male)',
  'fr-CA-Chirp3-HD-Vindemiatrix' = 'French (Canada) (Chirp3-HD-Vindemiatrix Female)',
  'fr-CA-Chirp3-HD-Zephyr' = 'French (Canada) (Chirp3-HD-Zephyr Female)',
  'fr-CA-Chirp3-HD-Zubenelgenubi' = 'French (Canada) (Chirp3-HD-Zubenelgenubi Male)',
  'fr-CA-Neural2-A' = 'French (Canada) (Neural2-A Female)',
  'fr-CA-Neural2-B' = 'French (Canada) (Neural2-B Male)',
  'fr-CA-Neural2-C' = 'French (Canada) (Neural2-C Female)',
  'fr-CA-Neural2-D' = 'French (Canada) (Neural2-D Male)',
  'fr-CA-Standard-A' = 'French (Canada) (Standard-A Female)',
  'fr-CA-Standard-B' = 'French (Canada) (Standard-B Male)',
  'fr-CA-Standard-C' = 'French (Canada) (Standard-C Female)',
  'fr-CA-Standard-D' = 'French (Canada) (Standard-D Male)',
  'fr-CA-Wavenet-A' = 'French (Canada) (Wavenet-A Female)',
  'fr-CA-Wavenet-B' = 'French (Canada) (Wavenet-B Male)',
  'fr-CA-Wavenet-C' = 'French (Canada) (Wavenet-C Female)',
  'fr-CA-Wavenet-D' = 'French (Canada) (Wavenet-D Male)',
  'fr-FR-Chirp-HD-D' = 'French (France) (Chirp-HD-D Male)',
  'fr-FR-Chirp-HD-F' = 'French (France) (Chirp-HD-F Female)',
  'fr-FR-Chirp-HD-O' = 'French (France) (Chirp-HD-O Female)',
  'fr-FR-Chirp3-HD-Achernar' = 'French (France) (Chirp3-HD-Achernar Female)',
  'fr-FR-Chirp3-HD-Achird' = 'French (France) (Chirp3-HD-Achird Male)',
  'fr-FR-Chirp3-HD-Algenib' = 'French (France) (Chirp3-HD-Algenib Male)',
  'fr-FR-Chirp3-HD-Algieba' = 'French (France) (Chirp3-HD-Algieba Male)',
  'fr-FR-Chirp3-HD-Alnilam' = 'French (France) (Chirp3-HD-Alnilam Male)',
  'fr-FR-Chirp3-HD-Aoede' = 'French (France) (Chirp3-HD-Aoede Female)',
  'fr-FR-Chirp3-HD-Autonoe' = 'French (France) (Chirp3-HD-Autonoe Female)',
  'fr-FR-Chirp3-HD-Callirrhoe' = 'French (France) (Chirp3-HD-Callirrhoe Female)',
  'fr-FR-Chirp3-HD-Charon' = 'French (France) (Chirp3-HD-Charon Male)',
  'fr-FR-Chirp3-HD-Despina' = 'French (France) (Chirp3-HD-Despina Female)',
  'fr-FR-Chirp3-HD-Enceladus' = 'French (France) (Chirp3-HD-Enceladus Male)',
  'fr-FR-Chirp3-HD-Erinome' = 'French (France) (Chirp3-HD-Erinome Female)',
  'fr-FR-Chirp3-HD-Fenrir' = 'French (France) (Chirp3-HD-Fenrir Male)',
  'fr-FR-Chirp3-HD-Gacrux' = 'French (France) (Chirp3-HD-Gacrux Female)',
  'fr-FR-Chirp3-HD-Iapetus' = 'French (France) (Chirp3-HD-Iapetus Male)',
  'fr-FR-Chirp3-HD-Kore' = 'French (France) (Chirp3-HD-Kore Female)',
  'fr-FR-Chirp3-HD-Laomedeia' = 'French (France) (Chirp3-HD-Laomedeia Female)',
  'fr-FR-Chirp3-HD-Leda' = 'French (France) (Chirp3-HD-Leda Female)',
  'fr-FR-Chirp3-HD-Orus' = 'French (France) (Chirp3-HD-Orus Male)',
  'fr-FR-Chirp3-HD-Puck' = 'French (France) (Chirp3-HD-Puck Male)',
  'fr-FR-Chirp3-HD-Pulcherrima' = 'French (France) (Chirp3-HD-Pulcherrima Female)',
  'fr-FR-Chirp3-HD-Rasalgethi' = 'French (France) (Chirp3-HD-Rasalgethi Male)',
  'fr-FR-Chirp3-HD-Sadachbia' = 'French (France) (Chirp3-HD-Sadachbia Male)',
  'fr-FR-Chirp3-HD-Sadaltager' = 'French (France) (Chirp3-HD-Sadaltager Male)',
  'fr-FR-Chirp3-HD-Schedar' = 'French (France) (Chirp3-HD-Schedar Male)',
  'fr-FR-Chirp3-HD-Sulafat' = 'French (France) (Chirp3-HD-Sulafat Female)',
  'fr-FR-Chirp3-HD-Umbriel' = 'French (France) (Chirp3-HD-Umbriel Male)',
  'fr-FR-Chirp3-HD-Vindemiatrix' = 'French (France) (Chirp3-HD-Vindemiatrix Female)',
  'fr-FR-Chirp3-HD-Zephyr' = 'French (France) (Chirp3-HD-Zephyr Female)',
  'fr-FR-Chirp3-HD-Zubenelgenubi' = 'French (France) (Chirp3-HD-Zubenelgenubi Male)',
  'fr-FR-Neural2-F' = 'French (France) (Neural2-F Female)',
  'fr-FR-Neural2-G' = 'French (France) (Neural2-G Male)',
  'fr-FR-Polyglot-1' = 'French (France) (Polyglot-1 Male)',
  'fr-FR-Standard-F' = 'French (France) (Standard-F Female)',
  'fr-FR-Standard-G' = 'French (France) (Standard-G Male)',
  'fr-FR-Studio-A' = 'French (France) (Studio-A Female)',
  'fr-FR-Studio-D' = 'French (France) (Studio-D Male)',
  'fr-FR-Wavenet-F' = 'French (France) (Wavenet-F Female)',
  'fr-FR-Wavenet-G' = 'French (France) (Wavenet-G Male)',
  'gl-ES-Standard-B' = 'Galician (Spain) (Standard-B Female)',
  'de-DE-Chirp-HD-D' = 'German (Germany) (Chirp-HD-D Male)',
  'de-DE-Chirp-HD-F' = 'German (Germany) (Chirp-HD-F Female)',
  'de-DE-Chirp-HD-O' = 'German (Germany) (Chirp-HD-O Female)',
  'de-DE-Chirp3-HD-Achernar' = 'German (Germany) (Chirp3-HD-Achernar Female)',
  'de-DE-Chirp3-HD-Achird' = 'German (Germany) (Chirp3-HD-Achird Male)',
  'de-DE-Chirp3-HD-Algenib' = 'German (Germany) (Chirp3-HD-Algenib Male)',
  'de-DE-Chirp3-HD-Algieba' = 'German (Germany) (Chirp3-HD-Algieba Male)',
  'de-DE-Chirp3-HD-Alnilam' = 'German (Germany) (Chirp3-HD-Alnilam Male)',
  'de-DE-Chirp3-HD-Aoede' = 'German (Germany) (Chirp3-HD-Aoede Female)',
  'de-DE-Chirp3-HD-Autonoe' = 'German (Germany) (Chirp3-HD-Autonoe Female)',
  'de-DE-Chirp3-HD-Callirrhoe' = 'German (Germany) (Chirp3-HD-Callirrhoe Female)',
  'de-DE-Chirp3-HD-Charon' = 'German (Germany) (Chirp3-HD-Charon Male)',
  'de-DE-Chirp3-HD-Despina' = 'German (Germany) (Chirp3-HD-Despina Female)',
  'de-DE-Chirp3-HD-Enceladus' = 'German (Germany) (Chirp3-HD-Enceladus Male)',
  'de-DE-Chirp3-HD-Erinome' = 'German (Germany) (Chirp3-HD-Erinome Female)',
  'de-DE-Chirp3-HD-Fenrir' = 'German (Germany) (Chirp3-HD-Fenrir Male)',
  'de-DE-Chirp3-HD-Gacrux' = 'German (Germany) (Chirp3-HD-Gacrux Female)',
  'de-DE-Chirp3-HD-Iapetus' = 'German (Germany) (Chirp3-HD-Iapetus Male)',
  'de-DE-Chirp3-HD-Kore' = 'German (Germany) (Chirp3-HD-Kore Female)',
  'de-DE-Chirp3-HD-Laomedeia' = 'German (Germany) (Chirp3-HD-Laomedeia Female)',
  'de-DE-Chirp3-HD-Leda' = 'German (Germany) (Chirp3-HD-Leda Female)',
  'de-DE-Chirp3-HD-Orus' = 'German (Germany) (Chirp3-HD-Orus Male)',
  'de-DE-Chirp3-HD-Puck' = 'German (Germany) (Chirp3-HD-Puck Male)',
  'de-DE-Chirp3-HD-Pulcherrima' = 'German (Germany) (Chirp3-HD-Pulcherrima Female)',
  'de-DE-Chirp3-HD-Rasalgethi' = 'German (Germany) (Chirp3-HD-Rasalgethi Male)',
  'de-DE-Chirp3-HD-Sadachbia' = 'German (Germany) (Chirp3-HD-Sadachbia Male)',
  'de-DE-Chirp3-HD-Sadaltager' = 'German (Germany) (Chirp3-HD-Sadaltager Male)',
  'de-DE-Chirp3-HD-Schedar' = 'German (Germany) (Chirp3-HD-Schedar Male)',
  'de-DE-Chirp3-HD-Sulafat' = 'German (Germany) (Chirp3-HD-Sulafat Female)',
  'de-DE-Chirp3-HD-Umbriel' = 'German (Germany) (Chirp3-HD-Umbriel Male)',
  'de-DE-Chirp3-HD-Vindemiatrix' = 'German (Germany) (Chirp3-HD-Vindemiatrix Female)',
  'de-DE-Chirp3-HD-Zephyr' = 'German (Germany) (Chirp3-HD-Zephyr Female)',
  'de-DE-Chirp3-HD-Zubenelgenubi' = 'German (Germany) (Chirp3-HD-Zubenelgenubi Male)',
  'de-DE-Neural2-G' = 'German (Germany) (Neural2-G Female)',
  'de-DE-Neural2-H' = 'German (Germany) (Neural2-H Male)',
  'de-DE-Polyglot-1' = 'German (Germany) (Polyglot-1 Male)',
  'de-DE-Standard-G' = 'German (Germany) (Standard-G Female)',
  'de-DE-Standard-H' = 'German (Germany) (Standard-H Male)',
  'de-DE-Studio-B' = 'German (Germany) (Studio-B Male)',
  'de-DE-Studio-C' = 'German (Germany) (Studio-C Female)',
  'de-DE-Wavenet-G' = 'German (Germany) (Wavenet-G Female)',
  'de-DE-Wavenet-H' = 'German (Germany) (Wavenet-H Male)',
  'el-GR-Standard-B' = 'Greek (Greece) (Standard-B Female)',
  'el-GR-Wavenet-B' = 'Greek (Greece) (Wavenet-B Female)',
  'gu-IN-Chirp3-HD-Achernar' = 'Gujarati (India) (Chirp3-HD-Achernar Female)',
  'gu-IN-Chirp3-HD-Achird' = 'Gujarati (India) (Chirp3-HD-Achird Male)',
  'gu-IN-Chirp3-HD-Algenib' = 'Gujarati (India) (Chirp3-HD-Algenib Male)',
  'gu-IN-Chirp3-HD-Algieba' = 'Gujarati (India) (Chirp3-HD-Algieba Male)',
  'gu-IN-Chirp3-HD-Alnilam' = 'Gujarati (India) (Chirp3-HD-Alnilam Male)',
  'gu-IN-Chirp3-HD-Aoede' = 'Gujarati (India) (Chirp3-HD-Aoede Female)',
  'gu-IN-Chirp3-HD-Autonoe' = 'Gujarati (India) (Chirp3-HD-Autonoe Female)',
  'gu-IN-Chirp3-HD-Callirrhoe' = 'Gujarati (India) (Chirp3-HD-Callirrhoe Female)',
  'gu-IN-Chirp3-HD-Charon' = 'Gujarati (India) (Chirp3-HD-Charon Male)',
  'gu-IN-Chirp3-HD-Despina' = 'Gujarati (India) (Chirp3-HD-Despina Female)',
  'gu-IN-Chirp3-HD-Enceladus' = 'Gujarati (India) (Chirp3-HD-Enceladus Male)',
  'gu-IN-Chirp3-HD-Erinome' = 'Gujarati (India) (Chirp3-HD-Erinome Female)',
  'gu-IN-Chirp3-HD-Fenrir' = 'Gujarati (India) (Chirp3-HD-Fenrir Male)',
  'gu-IN-Chirp3-HD-Gacrux' = 'Gujarati (India) (Chirp3-HD-Gacrux Female)',
  'gu-IN-Chirp3-HD-Iapetus' = 'Gujarati (India) (Chirp3-HD-Iapetus Male)',
  'gu-IN-Chirp3-HD-Kore' = 'Gujarati (India) (Chirp3-HD-Kore Female)',
  'gu-IN-Chirp3-HD-Laomedeia' = 'Gujarati (India) (Chirp3-HD-Laomedeia Female)',
  'gu-IN-Chirp3-HD-Leda' = 'Gujarati (India) (Chirp3-HD-Leda Female)',
  'gu-IN-Chirp3-HD-Orus' = 'Gujarati (India) (Chirp3-HD-Orus Male)',
  'gu-IN-Chirp3-HD-Puck' = 'Gujarati (India) (Chirp3-HD-Puck Male)',
  'gu-IN-Chirp3-HD-Pulcherrima' = 'Gujarati (India) (Chirp3-HD-Pulcherrima Female)',
  'gu-IN-Chirp3-HD-Rasalgethi' = 'Gujarati (India) (Chirp3-HD-Rasalgethi Male)',
  'gu-IN-Chirp3-HD-Sadachbia' = 'Gujarati (India) (Chirp3-HD-Sadachbia Male)',
  'gu-IN-Chirp3-HD-Sadaltager' = 'Gujarati (India) (Chirp3-HD-Sadaltager Male)',
  'gu-IN-Chirp3-HD-Schedar' = 'Gujarati (India) (Chirp3-HD-Schedar Male)',
  'gu-IN-Chirp3-HD-Sulafat' = 'Gujarati (India) (Chirp3-HD-Sulafat Female)',
  'gu-IN-Chirp3-HD-Umbriel' = 'Gujarati (India) (Chirp3-HD-Umbriel Male)',
  'gu-IN-Chirp3-HD-Vindemiatrix' = 'Gujarati (India) (Chirp3-HD-Vindemiatrix Female)',
  'gu-IN-Chirp3-HD-Zephyr' = 'Gujarati (India) (Chirp3-HD-Zephyr Female)',
  'gu-IN-Chirp3-HD-Zubenelgenubi' = 'Gujarati (India) (Chirp3-HD-Zubenelgenubi Male)',
  'gu-IN-Standard-A' = 'Gujarati (India) (Standard-A Female)',
  'gu-IN-Standard-B' = 'Gujarati (India) (Standard-B Male)',
  'gu-IN-Standard-C' = 'Gujarati (India) (Standard-C Female)',
  'gu-IN-Standard-D' = 'Gujarati (India) (Standard-D Male)',
  'gu-IN-Wavenet-A' = 'Gujarati (India) (Wavenet-A Female)',
  'gu-IN-Wavenet-B' = 'Gujarati (India) (Wavenet-B Male)',
  'gu-IN-Wavenet-C' = 'Gujarati (India) (Wavenet-C Female)',
  'gu-IN-Wavenet-D' = 'Gujarati (India) (Wavenet-D Male)',
  'he-IL-Standard-A' = 'Hebrew (Israel) (Standard-A Female)',
  'he-IL-Standard-B' = 'Hebrew (Israel) (Standard-B Male)',
  'he-IL-Standard-C' = 'Hebrew (Israel) (Standard-C Female)',
  'he-IL-Standard-D' = 'Hebrew (Israel) (Standard-D Male)',
  'he-IL-Wavenet-A' = 'Hebrew (Israel) (Wavenet-A Female)',
  'he-IL-Wavenet-B' = 'Hebrew (Israel) (Wavenet-B Male)',
  'he-IL-Wavenet-C' = 'Hebrew (Israel) (Wavenet-C Female)',
  'he-IL-Wavenet-D' = 'Hebrew (Israel) (Wavenet-D Male)',
  'hi-IN-Chirp3-HD-Achernar' = 'Hindi (India) (Chirp3-HD-Achernar Female)',
  'hi-IN-Chirp3-HD-Achird' = 'Hindi (India) (Chirp3-HD-Achird Male)',
  'hi-IN-Chirp3-HD-Algenib' = 'Hindi (India) (Chirp3-HD-Algenib Male)',
  'hi-IN-Chirp3-HD-Algieba' = 'Hindi (India) (Chirp3-HD-Algieba Male)',
  'hi-IN-Chirp3-HD-Alnilam' = 'Hindi (India) (Chirp3-HD-Alnilam Male)',
  'hi-IN-Chirp3-HD-Aoede' = 'Hindi (India) (Chirp3-HD-Aoede Female)',
  'hi-IN-Chirp3-HD-Autonoe' = 'Hindi (India) (Chirp3-HD-Autonoe Female)',
  'hi-IN-Chirp3-HD-Callirrhoe' = 'Hindi (India) (Chirp3-HD-Callirrhoe Female)',
  'hi-IN-Chirp3-HD-Charon' = 'Hindi (India) (Chirp3-HD-Charon Male)',
  'hi-IN-Chirp3-HD-Despina' = 'Hindi (India) (Chirp3-HD-Despina Female)',
  'hi-IN-Chirp3-HD-Enceladus' = 'Hindi (India) (Chirp3-HD-Enceladus Male)',
  'hi-IN-Chirp3-HD-Erinome' = 'Hindi (India) (Chirp3-HD-Erinome Female)',
  'hi-IN-Chirp3-HD-Fenrir' = 'Hindi (India) (Chirp3-HD-Fenrir Male)',
  'hi-IN-Chirp3-HD-Gacrux' = 'Hindi (India) (Chirp3-HD-Gacrux Female)',
  'hi-IN-Chirp3-HD-Iapetus' = 'Hindi (India) (Chirp3-HD-Iapetus Male)',
  'hi-IN-Chirp3-HD-Kore' = 'Hindi (India) (Chirp3-HD-Kore Female)',
  'hi-IN-Chirp3-HD-Laomedeia' = 'Hindi (India) (Chirp3-HD-Laomedeia Female)',
  'hi-IN-Chirp3-HD-Leda' = 'Hindi (India) (Chirp3-HD-Leda Female)',
  'hi-IN-Chirp3-HD-Orus' = 'Hindi (India) (Chirp3-HD-Orus Male)',
  'hi-IN-Chirp3-HD-Puck' = 'Hindi (India) (Chirp3-HD-Puck Male)',
  'hi-IN-Chirp3-HD-Pulcherrima' = 'Hindi (India) (Chirp3-HD-Pulcherrima Female)',
  'hi-IN-Chirp3-HD-Rasalgethi' = 'Hindi (India) (Chirp3-HD-Rasalgethi Male)',
  'hi-IN-Chirp3-HD-Sadachbia' = 'Hindi (India) (Chirp3-HD-Sadachbia Male)',
  'hi-IN-Chirp3-HD-Sadaltager' = 'Hindi (India) (Chirp3-HD-Sadaltager Male)',
  'hi-IN-Chirp3-HD-Schedar' = 'Hindi (India) (Chirp3-HD-Schedar Male)',
  'hi-IN-Chirp3-HD-Sulafat' = 'Hindi (India) (Chirp3-HD-Sulafat Female)',
  'hi-IN-Chirp3-HD-Umbriel' = 'Hindi (India) (Chirp3-HD-Umbriel Male)',
  'hi-IN-Chirp3-HD-Vindemiatrix' = 'Hindi (India) (Chirp3-HD-Vindemiatrix Female)',
  'hi-IN-Chirp3-HD-Zephyr' = 'Hindi (India) (Chirp3-HD-Zephyr Female)',
  'hi-IN-Chirp3-HD-Zubenelgenubi' = 'Hindi (India) (Chirp3-HD-Zubenelgenubi Male)',
  'hi-IN-Neural2-A' = 'Hindi (India) (Neural2-A Female)',
  'hi-IN-Neural2-B' = 'Hindi (India) (Neural2-B Male)',
  'hi-IN-Neural2-C' = 'Hindi (India) (Neural2-C Male)',
  'hi-IN-Neural2-D' = 'Hindi (India) (Neural2-D Female)',
  'hi-IN-Standard-A' = 'Hindi (India) (Standard-A Female)',
  'hi-IN-Standard-B' = 'Hindi (India) (Standard-B Male)',
  'hi-IN-Standard-C' = 'Hindi (India) (Standard-C Male)',
  'hi-IN-Standard-D' = 'Hindi (India) (Standard-D Female)',
  'hi-IN-Standard-E' = 'Hindi (India) (Standard-E Female)',
  'hi-IN-Standard-F' = 'Hindi (India) (Standard-F Male)',
  'hi-IN-Wavenet-A' = 'Hindi (India) (Wavenet-A Female)',
  'hi-IN-Wavenet-B' = 'Hindi (India) (Wavenet-B Male)',
  'hi-IN-Wavenet-C' = 'Hindi (India) (Wavenet-C Male)',
  'hi-IN-Wavenet-D' = 'Hindi (India) (Wavenet-D Female)',
  'hi-IN-Wavenet-E' = 'Hindi (India) (Wavenet-E Female)',
  'hi-IN-Wavenet-F' = 'Hindi (India) (Wavenet-F Male)',
  'hu-HU-Standard-B' = 'Hungarian (Hungary) (Standard-B Female)',
  'hu-HU-Wavenet-A' = 'Hungarian (Hungary) (Wavenet-A Female)',
  'is-IS-Standard-B' = 'Icelandic (Iceland) (Standard-B Female)',
  'id-ID-Chirp3-HD-Achernar' = 'Indonesian (Indonesia) (Chirp3-HD-Achernar Female)',
  'id-ID-Chirp3-HD-Achird' = 'Indonesian (Indonesia) (Chirp3-HD-Achird Male)',
  'id-ID-Chirp3-HD-Algenib' = 'Indonesian (Indonesia) (Chirp3-HD-Algenib Male)',
  'id-ID-Chirp3-HD-Algieba' = 'Indonesian (Indonesia) (Chirp3-HD-Algieba Male)',
  'id-ID-Chirp3-HD-Alnilam' = 'Indonesian (Indonesia) (Chirp3-HD-Alnilam Male)',
  'id-ID-Chirp3-HD-Aoede' = 'Indonesian (Indonesia) (Chirp3-HD-Aoede Female)',
  'id-ID-Chirp3-HD-Autonoe' = 'Indonesian (Indonesia) (Chirp3-HD-Autonoe Female)',
  'id-ID-Chirp3-HD-Callirrhoe' = 'Indonesian (Indonesia) (Chirp3-HD-Callirrhoe Female)',
  'id-ID-Chirp3-HD-Charon' = 'Indonesian (Indonesia) (Chirp3-HD-Charon Male)',
  'id-ID-Chirp3-HD-Despina' = 'Indonesian (Indonesia) (Chirp3-HD-Despina Female)',
  'id-ID-Chirp3-HD-Enceladus' = 'Indonesian (Indonesia) (Chirp3-HD-Enceladus Male)',
  'id-ID-Chirp3-HD-Erinome' = 'Indonesian (Indonesia) (Chirp3-HD-Erinome Female)',
  'id-ID-Chirp3-HD-Fenrir' = 'Indonesian (Indonesia) (Chirp3-HD-Fenrir Male)',
  'id-ID-Chirp3-HD-Gacrux' = 'Indonesian (Indonesia) (Chirp3-HD-Gacrux Female)',
  'id-ID-Chirp3-HD-Iapetus' = 'Indonesian (Indonesia) (Chirp3-HD-Iapetus Male)',
  'id-ID-Chirp3-HD-Kore' = 'Indonesian (Indonesia) (Chirp3-HD-Kore Female)',
  'id-ID-Chirp3-HD-Laomedeia' = 'Indonesian (Indonesia) (Chirp3-HD-Laomedeia Female)',
  'id-ID-Chirp3-HD-Leda' = 'Indonesian (Indonesia) (Chirp3-HD-Leda Female)',
  'id-ID-Chirp3-HD-Orus' = 'Indonesian (Indonesia) (Chirp3-HD-Orus Male)',
  'id-ID-Chirp3-HD-Puck' = 'Indonesian (Indonesia) (Chirp3-HD-Puck Male)',
  'id-ID-Chirp3-HD-Pulcherrima' = 'Indonesian (Indonesia) (Chirp3-HD-Pulcherrima Female)',
  'id-ID-Chirp3-HD-Rasalgethi' = 'Indonesian (Indonesia) (Chirp3-HD-Rasalgethi Male)',
  'id-ID-Chirp3-HD-Sadachbia' = 'Indonesian (Indonesia) (Chirp3-HD-Sadachbia Male)',
  'id-ID-Chirp3-HD-Sadaltager' = 'Indonesian (Indonesia) (Chirp3-HD-Sadaltager Male)',
  'id-ID-Chirp3-HD-Schedar' = 'Indonesian (Indonesia) (Chirp3-HD-Schedar Male)',
  'id-ID-Chirp3-HD-Sulafat' = 'Indonesian (Indonesia) (Chirp3-HD-Sulafat Female)',
  'id-ID-Chirp3-HD-Umbriel' = 'Indonesian (Indonesia) (Chirp3-HD-Umbriel Male)',
  'id-ID-Chirp3-HD-Vindemiatrix' = 'Indonesian (Indonesia) (Chirp3-HD-Vindemiatrix Female)',
  'id-ID-Chirp3-HD-Zephyr' = 'Indonesian (Indonesia) (Chirp3-HD-Zephyr Female)',
  'id-ID-Chirp3-HD-Zubenelgenubi' = 'Indonesian (Indonesia) (Chirp3-HD-Zubenelgenubi Male)',
  'id-ID-Standard-A' = 'Indonesian (Indonesia) (Standard-A Female)',
  'id-ID-Standard-B' = 'Indonesian (Indonesia) (Standard-B Male)',
  'id-ID-Standard-C' = 'Indonesian (Indonesia) (Standard-C Male)',
  'id-ID-Standard-D' = 'Indonesian (Indonesia) (Standard-D Female)',
  'id-ID-Wavenet-A' = 'Indonesian (Indonesia) (Wavenet-A Female)',
  'id-ID-Wavenet-B' = 'Indonesian (Indonesia) (Wavenet-B Male)',
  'id-ID-Wavenet-C' = 'Indonesian (Indonesia) (Wavenet-C Male)',
  'id-ID-Wavenet-D' = 'Indonesian (Indonesia) (Wavenet-D Female)',
  'it-IT-Chirp-HD-D' = 'Italian (Italy) (Chirp-HD-D Male)',
  'it-IT-Chirp-HD-F' = 'Italian (Italy) (Chirp-HD-F Female)',
  'it-IT-Chirp-HD-O' = 'Italian (Italy) (Chirp-HD-O Female)',
  'it-IT-Chirp3-HD-Achernar' = 'Italian (Italy) (Chirp3-HD-Achernar Female)',
  'it-IT-Chirp3-HD-Achird' = 'Italian (Italy) (Chirp3-HD-Achird Male)',
  'it-IT-Chirp3-HD-Algenib' = 'Italian (Italy) (Chirp3-HD-Algenib Male)',
  'it-IT-Chirp3-HD-Algieba' = 'Italian (Italy) (Chirp3-HD-Algieba Male)',
  'it-IT-Chirp3-HD-Alnilam' = 'Italian (Italy) (Chirp3-HD-Alnilam Male)',
  'it-IT-Chirp3-HD-Aoede' = 'Italian (Italy) (Chirp3-HD-Aoede Female)',
  'it-IT-Chirp3-HD-Autonoe' = 'Italian (Italy) (Chirp3-HD-Autonoe Female)',
  'it-IT-Chirp3-HD-Callirrhoe' = 'Italian (Italy) (Chirp3-HD-Callirrhoe Female)',
  'it-IT-Chirp3-HD-Charon' = 'Italian (Italy) (Chirp3-HD-Charon Male)',
  'it-IT-Chirp3-HD-Despina' = 'Italian (Italy) (Chirp3-HD-Despina Female)',
  'it-IT-Chirp3-HD-Enceladus' = 'Italian (Italy) (Chirp3-HD-Enceladus Male)',
  'it-IT-Chirp3-HD-Erinome' = 'Italian (Italy) (Chirp3-HD-Erinome Female)',
  'it-IT-Chirp3-HD-Fenrir' = 'Italian (Italy) (Chirp3-HD-Fenrir Male)',
  'it-IT-Chirp3-HD-Gacrux' = 'Italian (Italy) (Chirp3-HD-Gacrux Female)',
  'it-IT-Chirp3-HD-Iapetus' = 'Italian (Italy) (Chirp3-HD-Iapetus Male)',
  'it-IT-Chirp3-HD-Kore' = 'Italian (Italy) (Chirp3-HD-Kore Female)',
  'it-IT-Chirp3-HD-Laomedeia' = 'Italian (Italy) (Chirp3-HD-Laomedeia Female)',
  'it-IT-Chirp3-HD-Leda' = 'Italian (Italy) (Chirp3-HD-Leda Female)',
  'it-IT-Chirp3-HD-Orus' = 'Italian (Italy) (Chirp3-HD-Orus Male)',
  'it-IT-Chirp3-HD-Puck' = 'Italian (Italy) (Chirp3-HD-Puck Male)',
  'it-IT-Chirp3-HD-Pulcherrima' = 'Italian (Italy) (Chirp3-HD-Pulcherrima Female)',
  'it-IT-Chirp3-HD-Rasalgethi' = 'Italian (Italy) (Chirp3-HD-Rasalgethi Male)',
  'it-IT-Chirp3-HD-Sadachbia' = 'Italian (Italy) (Chirp3-HD-Sadachbia Male)',
  'it-IT-Chirp3-HD-Sadaltager' = 'Italian (Italy) (Chirp3-HD-Sadaltager Male)',
  'it-IT-Chirp3-HD-Schedar' = 'Italian (Italy) (Chirp3-HD-Schedar Male)',
  'it-IT-Chirp3-HD-Sulafat' = 'Italian (Italy) (Chirp3-HD-Sulafat Female)',
  'it-IT-Chirp3-HD-Umbriel' = 'Italian (Italy) (Chirp3-HD-Umbriel Male)',
  'it-IT-Chirp3-HD-Vindemiatrix' = 'Italian (Italy) (Chirp3-HD-Vindemiatrix Female)',
  'it-IT-Chirp3-HD-Zephyr' = 'Italian (Italy) (Chirp3-HD-Zephyr Female)',
  'it-IT-Chirp3-HD-Zubenelgenubi' = 'Italian (Italy) (Chirp3-HD-Zubenelgenubi Male)',
  'it-IT-Neural2-A' = 'Italian (Italy) (Neural2-A Female)',
  'it-IT-Neural2-E' = 'Italian (Italy) (Neural2-E Female)',
  'it-IT-Neural2-F' = 'Italian (Italy) (Neural2-F Male)',
  'it-IT-Standard-E' = 'Italian (Italy) (Standard-E Female)',
  'it-IT-Standard-F' = 'Italian (Italy) (Standard-F Male)',
  'it-IT-Wavenet-E' = 'Italian (Italy) (Wavenet-E Female)',
  'it-IT-Wavenet-F' = 'Italian (Italy) (Wavenet-F Male)',
  'ja-JP-Chirp3-HD-Achernar' = 'Japanese (Japan) (Chirp3-HD-Achernar Female)',
  'ja-JP-Chirp3-HD-Achird' = 'Japanese (Japan) (Chirp3-HD-Achird Male)',
  'ja-JP-Chirp3-HD-Algenib' = 'Japanese (Japan) (Chirp3-HD-Algenib Male)',
  'ja-JP-Chirp3-HD-Algieba' = 'Japanese (Japan) (Chirp3-HD-Algieba Male)',
  'ja-JP-Chirp3-HD-Alnilam' = 'Japanese (Japan) (Chirp3-HD-Alnilam Male)',
  'ja-JP-Chirp3-HD-Aoede' = 'Japanese (Japan) (Chirp3-HD-Aoede Female)',
  'ja-JP-Chirp3-HD-Autonoe' = 'Japanese (Japan) (Chirp3-HD-Autonoe Female)',
  'ja-JP-Chirp3-HD-Callirrhoe' = 'Japanese (Japan) (Chirp3-HD-Callirrhoe Female)',
  'ja-JP-Chirp3-HD-Charon' = 'Japanese (Japan) (Chirp3-HD-Charon Male)',
  'ja-JP-Chirp3-HD-Despina' = 'Japanese (Japan) (Chirp3-HD-Despina Female)',
  'ja-JP-Chirp3-HD-Enceladus' = 'Japanese (Japan) (Chirp3-HD-Enceladus Male)',
  'ja-JP-Chirp3-HD-Erinome' = 'Japanese (Japan) (Chirp3-HD-Erinome Female)',
  'ja-JP-Chirp3-HD-Fenrir' = 'Japanese (Japan) (Chirp3-HD-Fenrir Male)',
  'ja-JP-Chirp3-HD-Gacrux' = 'Japanese (Japan) (Chirp3-HD-Gacrux Female)',
  'ja-JP-Chirp3-HD-Iapetus' = 'Japanese (Japan) (Chirp3-HD-Iapetus Male)',
  'ja-JP-Chirp3-HD-Kore' = 'Japanese (Japan) (Chirp3-HD-Kore Female)',
  'ja-JP-Chirp3-HD-Laomedeia' = 'Japanese (Japan) (Chirp3-HD-Laomedeia Female)',
  'ja-JP-Chirp3-HD-Leda' = 'Japanese (Japan) (Chirp3-HD-Leda Female)',
  'ja-JP-Chirp3-HD-Orus' = 'Japanese (Japan) (Chirp3-HD-Orus Male)',
  'ja-JP-Chirp3-HD-Puck' = 'Japanese (Japan) (Chirp3-HD-Puck Male)',
  'ja-JP-Chirp3-HD-Pulcherrima' = 'Japanese (Japan) (Chirp3-HD-Pulcherrima Female)',
  'ja-JP-Chirp3-HD-Rasalgethi' = 'Japanese (Japan) (Chirp3-HD-Rasalgethi Male)',
  'ja-JP-Chirp3-HD-Sadachbia' = 'Japanese (Japan) (Chirp3-HD-Sadachbia Male)',
  'ja-JP-Chirp3-HD-Sadaltager' = 'Japanese (Japan) (Chirp3-HD-Sadaltager Male)',
  'ja-JP-Chirp3-HD-Schedar' = 'Japanese (Japan) (Chirp3-HD-Schedar Male)',
  'ja-JP-Chirp3-HD-Sulafat' = 'Japanese (Japan) (Chirp3-HD-Sulafat Female)',
  'ja-JP-Chirp3-HD-Umbriel' = 'Japanese (Japan) (Chirp3-HD-Umbriel Male)',
  'ja-JP-Chirp3-HD-Vindemiatrix' = 'Japanese (Japan) (Chirp3-HD-Vindemiatrix Female)',
  'ja-JP-Chirp3-HD-Zephyr' = 'Japanese (Japan) (Chirp3-HD-Zephyr Female)',
  'ja-JP-Chirp3-HD-Zubenelgenubi' = 'Japanese (Japan) (Chirp3-HD-Zubenelgenubi Male)',
  'ja-JP-Neural2-B' = 'Japanese (Japan) (Neural2-B Female)',
  'ja-JP-Neural2-C' = 'Japanese (Japan) (Neural2-C Male)',
  'ja-JP-Neural2-D' = 'Japanese (Japan) (Neural2-D Male)',
  'ja-JP-Standard-A' = 'Japanese (Japan) (Standard-A Female)',
  'ja-JP-Standard-B' = 'Japanese (Japan) (Standard-B Female)',
  'ja-JP-Standard-C' = 'Japanese (Japan) (Standard-C Male)',
  'ja-JP-Standard-D' = 'Japanese (Japan) (Standard-D Male)',
  'ja-JP-Wavenet-A' = 'Japanese (Japan) (Wavenet-A Female)',
  'ja-JP-Wavenet-B' = 'Japanese (Japan) (Wavenet-B Female)',
  'ja-JP-Wavenet-C' = 'Japanese (Japan) (Wavenet-C Male)',
  'ja-JP-Wavenet-D' = 'Japanese (Japan) (Wavenet-D Male)',
  'kn-IN-Chirp3-HD-Achernar' = 'Kannada (India) (Chirp3-HD-Achernar Female)',
  'kn-IN-Chirp3-HD-Achird' = 'Kannada (India) (Chirp3-HD-Achird Male)',
  'kn-IN-Chirp3-HD-Algenib' = 'Kannada (India) (Chirp3-HD-Algenib Male)',
  'kn-IN-Chirp3-HD-Algieba' = 'Kannada (India) (Chirp3-HD-Algieba Male)',
  'kn-IN-Chirp3-HD-Alnilam' = 'Kannada (India) (Chirp3-HD-Alnilam Male)',
  'kn-IN-Chirp3-HD-Aoede' = 'Kannada (India) (Chirp3-HD-Aoede Female)',
  'kn-IN-Chirp3-HD-Autonoe' = 'Kannada (India) (Chirp3-HD-Autonoe Female)',
  'kn-IN-Chirp3-HD-Callirrhoe' = 'Kannada (India) (Chirp3-HD-Callirrhoe Female)',
  'kn-IN-Chirp3-HD-Charon' = 'Kannada (India) (Chirp3-HD-Charon Male)',
  'kn-IN-Chirp3-HD-Despina' = 'Kannada (India) (Chirp3-HD-Despina Female)',
  'kn-IN-Chirp3-HD-Enceladus' = 'Kannada (India) (Chirp3-HD-Enceladus Male)',
  'kn-IN-Chirp3-HD-Erinome' = 'Kannada (India) (Chirp3-HD-Erinome Female)',
  'kn-IN-Chirp3-HD-Fenrir' = 'Kannada (India) (Chirp3-HD-Fenrir Male)',
  'kn-IN-Chirp3-HD-Gacrux' = 'Kannada (India) (Chirp3-HD-Gacrux Female)',
  'kn-IN-Chirp3-HD-Iapetus' = 'Kannada (India) (Chirp3-HD-Iapetus Male)',
  'kn-IN-Chirp3-HD-Kore' = 'Kannada (India) (Chirp3-HD-Kore Female)',
  'kn-IN-Chirp3-HD-Laomedeia' = 'Kannada (India) (Chirp3-HD-Laomedeia Female)',
  'kn-IN-Chirp3-HD-Leda' = 'Kannada (India) (Chirp3-HD-Leda Female)',
  'kn-IN-Chirp3-HD-Orus' = 'Kannada (India) (Chirp3-HD-Orus Male)',
  'kn-IN-Chirp3-HD-Puck' = 'Kannada (India) (Chirp3-HD-Puck Male)',
  'kn-IN-Chirp3-HD-Pulcherrima' = 'Kannada (India) (Chirp3-HD-Pulcherrima Female)',
  'kn-IN-Chirp3-HD-Rasalgethi' = 'Kannada (India) (Chirp3-HD-Rasalgethi Male)',
  'kn-IN-Chirp3-HD-Sadachbia' = 'Kannada (India) (Chirp3-HD-Sadachbia Male)',
  'kn-IN-Chirp3-HD-Sadaltager' = 'Kannada (India) (Chirp3-HD-Sadaltager Male)',
  'kn-IN-Chirp3-HD-Schedar' = 'Kannada (India) (Chirp3-HD-Schedar Male)',
  'kn-IN-Chirp3-HD-Sulafat' = 'Kannada (India) (Chirp3-HD-Sulafat Female)',
  'kn-IN-Chirp3-HD-Umbriel' = 'Kannada (India) (Chirp3-HD-Umbriel Male)',
  'kn-IN-Chirp3-HD-Vindemiatrix' = 'Kannada (India) (Chirp3-HD-Vindemiatrix Female)',
  'kn-IN-Chirp3-HD-Zephyr' = 'Kannada (India) (Chirp3-HD-Zephyr Female)',
  'kn-IN-Chirp3-HD-Zubenelgenubi' = 'Kannada (India) (Chirp3-HD-Zubenelgenubi Male)',
  'kn-IN-Standard-A' = 'Kannada (India) (Standard-A Female)',
  'kn-IN-Standard-B' = 'Kannada (India) (Standard-B Male)',
  'kn-IN-Standard-C' = 'Kannada (India) (Standard-C Female)',
  'kn-IN-Standard-D' = 'Kannada (India) (Standard-D Male)',
  'kn-IN-Wavenet-A' = 'Kannada (India) (Wavenet-A Female)',
  'kn-IN-Wavenet-B' = 'Kannada (India) (Wavenet-B Male)',
  'kn-IN-Wavenet-C' = 'Kannada (India) (Wavenet-C Female)',
  'kn-IN-Wavenet-D' = 'Kannada (India) (Wavenet-D Male)',
  'ko-KR-Chirp3-HD-Achernar' = 'Korean (South Korea) (Chirp3-HD-Achernar Female)',
  'ko-KR-Chirp3-HD-Achird' = 'Korean (South Korea) (Chirp3-HD-Achird Male)',
  'ko-KR-Chirp3-HD-Algenib' = 'Korean (South Korea) (Chirp3-HD-Algenib Male)',
  'ko-KR-Chirp3-HD-Algieba' = 'Korean (South Korea) (Chirp3-HD-Algieba Male)',
  'ko-KR-Chirp3-HD-Alnilam' = 'Korean (South Korea) (Chirp3-HD-Alnilam Male)',
  'ko-KR-Chirp3-HD-Aoede' = 'Korean (South Korea) (Chirp3-HD-Aoede Female)',
  'ko-KR-Chirp3-HD-Autonoe' = 'Korean (South Korea) (Chirp3-HD-Autonoe Female)',
  'ko-KR-Chirp3-HD-Callirrhoe' = 'Korean (South Korea) (Chirp3-HD-Callirrhoe Female)',
  'ko-KR-Chirp3-HD-Charon' = 'Korean (South Korea) (Chirp3-HD-Charon Male)',
  'ko-KR-Chirp3-HD-Despina' = 'Korean (South Korea) (Chirp3-HD-Despina Female)',
  'ko-KR-Chirp3-HD-Enceladus' = 'Korean (South Korea) (Chirp3-HD-Enceladus Male)',
  'ko-KR-Chirp3-HD-Erinome' = 'Korean (South Korea) (Chirp3-HD-Erinome Female)',
  'ko-KR-Chirp3-HD-Fenrir' = 'Korean (South Korea) (Chirp3-HD-Fenrir Male)',
  'ko-KR-Chirp3-HD-Gacrux' = 'Korean (South Korea) (Chirp3-HD-Gacrux Female)',
  'ko-KR-Chirp3-HD-Iapetus' = 'Korean (South Korea) (Chirp3-HD-Iapetus Male)',
  'ko-KR-Chirp3-HD-Kore' = 'Korean (South Korea) (Chirp3-HD-Kore Female)',
  'ko-KR-Chirp3-HD-Laomedeia' = 'Korean (South Korea) (Chirp3-HD-Laomedeia Female)',
  'ko-KR-Chirp3-HD-Leda' = 'Korean (South Korea) (Chirp3-HD-Leda Female)',
  'ko-KR-Chirp3-HD-Orus' = 'Korean (South Korea) (Chirp3-HD-Orus Male)',
  'ko-KR-Chirp3-HD-Puck' = 'Korean (South Korea) (Chirp3-HD-Puck Male)',
  'ko-KR-Chirp3-HD-Pulcherrima' = 'Korean (South Korea) (Chirp3-HD-Pulcherrima Female)',
  'ko-KR-Chirp3-HD-Rasalgethi' = 'Korean (South Korea) (Chirp3-HD-Rasalgethi Male)',
  'ko-KR-Chirp3-HD-Sadachbia' = 'Korean (South Korea) (Chirp3-HD-Sadachbia Male)',
  'ko-KR-Chirp3-HD-Sadaltager' = 'Korean (South Korea) (Chirp3-HD-Sadaltager Male)',
  'ko-KR-Chirp3-HD-Schedar' = 'Korean (South Korea) (Chirp3-HD-Schedar Male)',
  'ko-KR-Chirp3-HD-Sulafat' = 'Korean (South Korea) (Chirp3-HD-Sulafat Female)',
  'ko-KR-Chirp3-HD-Umbriel' = 'Korean (South Korea) (Chirp3-HD-Umbriel Male)',
  'ko-KR-Chirp3-HD-Vindemiatrix' = 'Korean (South Korea) (Chirp3-HD-Vindemiatrix Female)',
  'ko-KR-Chirp3-HD-Zephyr' = 'Korean (South Korea) (Chirp3-HD-Zephyr Female)',
  'ko-KR-Chirp3-HD-Zubenelgenubi' = 'Korean (South Korea) (Chirp3-HD-Zubenelgenubi Male)',
  'ko-KR-Neural2-A' = 'Korean (South Korea) (Neural2-A Female)',
  'ko-KR-Neural2-B' = 'Korean (South Korea) (Neural2-B Female)',
  'ko-KR-Neural2-C' = 'Korean (South Korea) (Neural2-C Male)',
  'ko-KR-Standard-A' = 'Korean (South Korea) (Standard-A Female)',
  'ko-KR-Standard-B' = 'Korean (South Korea) (Standard-B Female)',
  'ko-KR-Standard-C' = 'Korean (South Korea) (Standard-C Male)',
  'ko-KR-Standard-D' = 'Korean (South Korea) (Standard-D Male)',
  'ko-KR-Wavenet-A' = 'Korean (South Korea) (Wavenet-A Female)',
  'ko-KR-Wavenet-B' = 'Korean (South Korea) (Wavenet-B Female)',
  'ko-KR-Wavenet-C' = 'Korean (South Korea) (Wavenet-C Male)',
  'ko-KR-Wavenet-D' = 'Korean (South Korea) (Wavenet-D Male)',
  'lv-LV-Standard-B' = 'Latvian (Latvia) (Standard-B Male)',
  'lt-LT-Standard-B' = 'Lithuanian (Lithuania) (Standard-B Male)',
  'ms-MY-Standard-A' = 'Malay (Malaysia) (Standard-A Female)',
  'ms-MY-Standard-B' = 'Malay (Malaysia) (Standard-B Male)',
  'ms-MY-Standard-C' = 'Malay (Malaysia) (Standard-C Female)',
  'ms-MY-Standard-D' = 'Malay (Malaysia) (Standard-D Male)',
  'ms-MY-Wavenet-A' = 'Malay (Malaysia) (Wavenet-A Female)',
  'ms-MY-Wavenet-B' = 'Malay (Malaysia) (Wavenet-B Male)',
  'ms-MY-Wavenet-C' = 'Malay (Malaysia) (Wavenet-C Female)',
  'ms-MY-Wavenet-D' = 'Malay (Malaysia) (Wavenet-D Male)',
  'ml-IN-Chirp3-HD-Achernar' = 'Malayalam (India) (Chirp3-HD-Achernar Female)',
  'ml-IN-Chirp3-HD-Achird' = 'Malayalam (India) (Chirp3-HD-Achird Male)',
  'ml-IN-Chirp3-HD-Algenib' = 'Malayalam (India) (Chirp3-HD-Algenib Male)',
  'ml-IN-Chirp3-HD-Algieba' = 'Malayalam (India) (Chirp3-HD-Algieba Male)',
  'ml-IN-Chirp3-HD-Alnilam' = 'Malayalam (India) (Chirp3-HD-Alnilam Male)',
  'ml-IN-Chirp3-HD-Aoede' = 'Malayalam (India) (Chirp3-HD-Aoede Female)',
  'ml-IN-Chirp3-HD-Autonoe' = 'Malayalam (India) (Chirp3-HD-Autonoe Female)',
  'ml-IN-Chirp3-HD-Callirrhoe' = 'Malayalam (India) (Chirp3-HD-Callirrhoe Female)',
  'ml-IN-Chirp3-HD-Charon' = 'Malayalam (India) (Chirp3-HD-Charon Male)',
  'ml-IN-Chirp3-HD-Despina' = 'Malayalam (India) (Chirp3-HD-Despina Female)',
  'ml-IN-Chirp3-HD-Enceladus' = 'Malayalam (India) (Chirp3-HD-Enceladus Male)',
  'ml-IN-Chirp3-HD-Erinome' = 'Malayalam (India) (Chirp3-HD-Erinome Female)',
  'ml-IN-Chirp3-HD-Fenrir' = 'Malayalam (India) (Chirp3-HD-Fenrir Male)',
  'ml-IN-Chirp3-HD-Gacrux' = 'Malayalam (India) (Chirp3-HD-Gacrux Female)',
  'ml-IN-Chirp3-HD-Iapetus' = 'Malayalam (India) (Chirp3-HD-Iapetus Male)',
  'ml-IN-Chirp3-HD-Kore' = 'Malayalam (India) (Chirp3-HD-Kore Female)',
  'ml-IN-Chirp3-HD-Laomedeia' = 'Malayalam (India) (Chirp3-HD-Laomedeia Female)',
  'ml-IN-Chirp3-HD-Leda' = 'Malayalam (India) (Chirp3-HD-Leda Female)',
  'ml-IN-Chirp3-HD-Orus' = 'Malayalam (India) (Chirp3-HD-Orus Male)',
  'ml-IN-Chirp3-HD-Puck' = 'Malayalam (India) (Chirp3-HD-Puck Male)',
  'ml-IN-Chirp3-HD-Pulcherrima' = 'Malayalam (India) (Chirp3-HD-Pulcherrima Female)',
  'ml-IN-Chirp3-HD-Rasalgethi' = 'Malayalam (India) (Chirp3-HD-Rasalgethi Male)',
  'ml-IN-Chirp3-HD-Sadachbia' = 'Malayalam (India) (Chirp3-HD-Sadachbia Male)',
  'ml-IN-Chirp3-HD-Sadaltager' = 'Malayalam (India) (Chirp3-HD-Sadaltager Male)',
  'ml-IN-Chirp3-HD-Schedar' = 'Malayalam (India) (Chirp3-HD-Schedar Male)',
  'ml-IN-Chirp3-HD-Sulafat' = 'Malayalam (India) (Chirp3-HD-Sulafat Female)',
  'ml-IN-Chirp3-HD-Umbriel' = 'Malayalam (India) (Chirp3-HD-Umbriel Male)',
  'ml-IN-Chirp3-HD-Vindemiatrix' = 'Malayalam (India) (Chirp3-HD-Vindemiatrix Female)',
  'ml-IN-Chirp3-HD-Zephyr' = 'Malayalam (India) (Chirp3-HD-Zephyr Female)',
  'ml-IN-Chirp3-HD-Zubenelgenubi' = 'Malayalam (India) (Chirp3-HD-Zubenelgenubi Male)',
  'ml-IN-Standard-A' = 'Malayalam (India) (Standard-A Female)',
  'ml-IN-Standard-B' = 'Malayalam (India) (Standard-B Male)',
  'ml-IN-Standard-C' = 'Malayalam (India) (Standard-C Female)',
  'ml-IN-Standard-D' = 'Malayalam (India) (Standard-D Male)',
  'ml-IN-Wavenet-A' = 'Malayalam (India) (Wavenet-A Female)',
  'ml-IN-Wavenet-B' = 'Malayalam (India) (Wavenet-B Male)',
  'ml-IN-Wavenet-C' = 'Malayalam (India) (Wavenet-C Female)',
  'ml-IN-Wavenet-D' = 'Malayalam (India) (Wavenet-D Male)',
  'cmn-CN-Chirp3-HD-Achernar' = 'Mandarin Chinese (Chirp3-HD-Achernar Female)',
  'cmn-CN-Chirp3-HD-Achird' = 'Mandarin Chinese (Chirp3-HD-Achird Male)',
  'cmn-CN-Chirp3-HD-Algenib' = 'Mandarin Chinese (Chirp3-HD-Algenib Male)',
  'cmn-CN-Chirp3-HD-Algieba' = 'Mandarin Chinese (Chirp3-HD-Algieba Male)',
  'cmn-CN-Chirp3-HD-Alnilam' = 'Mandarin Chinese (Chirp3-HD-Alnilam Male)',
  'cmn-CN-Chirp3-HD-Aoede' = 'Mandarin Chinese (Chirp3-HD-Aoede Female)',
  'cmn-CN-Chirp3-HD-Autonoe' = 'Mandarin Chinese (Chirp3-HD-Autonoe Female)',
  'cmn-CN-Chirp3-HD-Callirrhoe' = 'Mandarin Chinese (Chirp3-HD-Callirrhoe Female)',
  'cmn-CN-Chirp3-HD-Charon' = 'Mandarin Chinese (Chirp3-HD-Charon Male)',
  'cmn-CN-Chirp3-HD-Despina' = 'Mandarin Chinese (Chirp3-HD-Despina Female)',
  'cmn-CN-Chirp3-HD-Enceladus' = 'Mandarin Chinese (Chirp3-HD-Enceladus Male)',
  'cmn-CN-Chirp3-HD-Erinome' = 'Mandarin Chinese (Chirp3-HD-Erinome Female)',
  'cmn-CN-Chirp3-HD-Fenrir' = 'Mandarin Chinese (Chirp3-HD-Fenrir Male)',
  'cmn-CN-Chirp3-HD-Gacrux' = 'Mandarin Chinese (Chirp3-HD-Gacrux Female)',
  'cmn-CN-Chirp3-HD-Iapetus' = 'Mandarin Chinese (Chirp3-HD-Iapetus Male)',
  'cmn-CN-Chirp3-HD-Kore' = 'Mandarin Chinese (Chirp3-HD-Kore Female)',
  'cmn-CN-Chirp3-HD-Laomedeia' = 'Mandarin Chinese (Chirp3-HD-Laomedeia Female)',
  'cmn-CN-Chirp3-HD-Leda' = 'Mandarin Chinese (Chirp3-HD-Leda Female)',
  'cmn-CN-Chirp3-HD-Orus' = 'Mandarin Chinese (Chirp3-HD-Orus Male)',
  'cmn-CN-Chirp3-HD-Puck' = 'Mandarin Chinese (Chirp3-HD-Puck Male)',
  'cmn-CN-Chirp3-HD-Pulcherrima' = 'Mandarin Chinese (Chirp3-HD-Pulcherrima Female)',
  'cmn-CN-Chirp3-HD-Rasalgethi' = 'Mandarin Chinese (Chirp3-HD-Rasalgethi Male)',
  'cmn-CN-Chirp3-HD-Sadachbia' = 'Mandarin Chinese (Chirp3-HD-Sadachbia Male)',
  'cmn-CN-Chirp3-HD-Sadaltager' = 'Mandarin Chinese (Chirp3-HD-Sadaltager Male)',
  'cmn-CN-Chirp3-HD-Schedar' = 'Mandarin Chinese (Chirp3-HD-Schedar Male)',
  'cmn-CN-Chirp3-HD-Sulafat' = 'Mandarin Chinese (Chirp3-HD-Sulafat Female)',
  'cmn-CN-Chirp3-HD-Umbriel' = 'Mandarin Chinese (Chirp3-HD-Umbriel Male)',
  'cmn-CN-Chirp3-HD-Vindemiatrix' = 'Mandarin Chinese (Chirp3-HD-Vindemiatrix Female)',
  'cmn-CN-Chirp3-HD-Zephyr' = 'Mandarin Chinese (Chirp3-HD-Zephyr Female)',
  'cmn-CN-Chirp3-HD-Zubenelgenubi' = 'Mandarin Chinese (Chirp3-HD-Zubenelgenubi Male)',
  'cmn-CN-Standard-A' = 'Mandarin Chinese (Standard-A Female)',
  'cmn-CN-Standard-B' = 'Mandarin Chinese (Standard-B Male)',
  'cmn-CN-Standard-C' = 'Mandarin Chinese (Standard-C Male)',
  'cmn-CN-Standard-D' = 'Mandarin Chinese (Standard-D Female)',
  'cmn-CN-Wavenet-A' = 'Mandarin Chinese (Wavenet-A Female)',
  'cmn-CN-Wavenet-B' = 'Mandarin Chinese (Wavenet-B Male)',
  'cmn-CN-Wavenet-C' = 'Mandarin Chinese (Wavenet-C Male)',
  'cmn-CN-Wavenet-D' = 'Mandarin Chinese (Wavenet-D Female)',
  'cmn-TW-Standard-A' = 'Mandarin Chinese TW (Standard-A Female)',
  'cmn-TW-Standard-B' = 'Mandarin Chinese TW (Standard-B Male)',
  'cmn-TW-Standard-C' = 'Mandarin Chinese TW (Standard-C Male)',
  'cmn-TW-Wavenet-A' = 'Mandarin Chinese TW (Wavenet-A Female)',
  'cmn-TW-Wavenet-B' = 'Mandarin Chinese TW (Wavenet-B Male)',
  'cmn-TW-Wavenet-C' = 'Mandarin Chinese TW (Wavenet-C Male)',
  'mr-IN-Chirp3-HD-Achernar' = 'Marathi (India) (Chirp3-HD-Achernar Female)',
  'mr-IN-Chirp3-HD-Achird' = 'Marathi (India) (Chirp3-HD-Achird Male)',
  'mr-IN-Chirp3-HD-Algenib' = 'Marathi (India) (Chirp3-HD-Algenib Male)',
  'mr-IN-Chirp3-HD-Algieba' = 'Marathi (India) (Chirp3-HD-Algieba Male)',
  'mr-IN-Chirp3-HD-Alnilam' = 'Marathi (India) (Chirp3-HD-Alnilam Male)',
  'mr-IN-Chirp3-HD-Aoede' = 'Marathi (India) (Chirp3-HD-Aoede Female)',
  'mr-IN-Chirp3-HD-Autonoe' = 'Marathi (India) (Chirp3-HD-Autonoe Female)',
  'mr-IN-Chirp3-HD-Callirrhoe' = 'Marathi (India) (Chirp3-HD-Callirrhoe Female)',
  'mr-IN-Chirp3-HD-Charon' = 'Marathi (India) (Chirp3-HD-Charon Male)',
  'mr-IN-Chirp3-HD-Despina' = 'Marathi (India) (Chirp3-HD-Despina Female)',
  'mr-IN-Chirp3-HD-Enceladus' = 'Marathi (India) (Chirp3-HD-Enceladus Male)',
  'mr-IN-Chirp3-HD-Erinome' = 'Marathi (India) (Chirp3-HD-Erinome Female)',
  'mr-IN-Chirp3-HD-Fenrir' = 'Marathi (India) (Chirp3-HD-Fenrir Male)',
  'mr-IN-Chirp3-HD-Gacrux' = 'Marathi (India) (Chirp3-HD-Gacrux Female)',
  'mr-IN-Chirp3-HD-Iapetus' = 'Marathi (India) (Chirp3-HD-Iapetus Male)',
  'mr-IN-Chirp3-HD-Kore' = 'Marathi (India) (Chirp3-HD-Kore Female)',
  'mr-IN-Chirp3-HD-Laomedeia' = 'Marathi (India) (Chirp3-HD-Laomedeia Female)',
  'mr-IN-Chirp3-HD-Leda' = 'Marathi (India) (Chirp3-HD-Leda Female)',
  'mr-IN-Chirp3-HD-Orus' = 'Marathi (India) (Chirp3-HD-Orus Male)',
  'mr-IN-Chirp3-HD-Puck' = 'Marathi (India) (Chirp3-HD-Puck Male)',
  'mr-IN-Chirp3-HD-Pulcherrima' = 'Marathi (India) (Chirp3-HD-Pulcherrima Female)',
  'mr-IN-Chirp3-HD-Rasalgethi' = 'Marathi (India) (Chirp3-HD-Rasalgethi Male)',
  'mr-IN-Chirp3-HD-Sadachbia' = 'Marathi (India) (Chirp3-HD-Sadachbia Male)',
  'mr-IN-Chirp3-HD-Sadaltager' = 'Marathi (India) (Chirp3-HD-Sadaltager Male)',
  'mr-IN-Chirp3-HD-Schedar' = 'Marathi (India) (Chirp3-HD-Schedar Male)',
  'mr-IN-Chirp3-HD-Sulafat' = 'Marathi (India) (Chirp3-HD-Sulafat Female)',
  'mr-IN-Chirp3-HD-Umbriel' = 'Marathi (India) (Chirp3-HD-Umbriel Male)',
  'mr-IN-Chirp3-HD-Vindemiatrix' = 'Marathi (India) (Chirp3-HD-Vindemiatrix Female)',
  'mr-IN-Chirp3-HD-Zephyr' = 'Marathi (India) (Chirp3-HD-Zephyr Female)',
  'mr-IN-Chirp3-HD-Zubenelgenubi' = 'Marathi (India) (Chirp3-HD-Zubenelgenubi Male)',
  'mr-IN-Standard-A' = 'Marathi (India) (Standard-A Female)',
  'mr-IN-Standard-B' = 'Marathi (India) (Standard-B Male)',
  'mr-IN-Standard-C' = 'Marathi (India) (Standard-C Female)',
  'mr-IN-Wavenet-A' = 'Marathi (India) (Wavenet-A Female)',
  'mr-IN-Wavenet-B' = 'Marathi (India) (Wavenet-B Male)',
  'mr-IN-Wavenet-C' = 'Marathi (India) (Wavenet-C Female)',
  'nb-NO-Standard-F' = 'Norwegian (Norway) (Standard-F Female)',
  'nb-NO-Standard-G' = 'Norwegian (Norway) (Standard-G Male)',
  'nb-NO-Wavenet-F' = 'Norwegian (Norway) (Wavenet-F Female)',
  'nb-NO-Wavenet-G' = 'Norwegian (Norway) (Wavenet-G Male)',
  'pl-PL-Chirp3-HD-Achernar' = 'Polish (Poland) (Chirp3-HD-Achernar Female)',
  'pl-PL-Chirp3-HD-Achird' = 'Polish (Poland) (Chirp3-HD-Achird Male)',
  'pl-PL-Chirp3-HD-Algenib' = 'Polish (Poland) (Chirp3-HD-Algenib Male)',
  'pl-PL-Chirp3-HD-Algieba' = 'Polish (Poland) (Chirp3-HD-Algieba Male)',
  'pl-PL-Chirp3-HD-Alnilam' = 'Polish (Poland) (Chirp3-HD-Alnilam Male)',
  'pl-PL-Chirp3-HD-Aoede' = 'Polish (Poland) (Chirp3-HD-Aoede Female)',
  'pl-PL-Chirp3-HD-Autonoe' = 'Polish (Poland) (Chirp3-HD-Autonoe Female)',
  'pl-PL-Chirp3-HD-Callirrhoe' = 'Polish (Poland) (Chirp3-HD-Callirrhoe Female)',
  'pl-PL-Chirp3-HD-Charon' = 'Polish (Poland) (Chirp3-HD-Charon Male)',
  'pl-PL-Chirp3-HD-Despina' = 'Polish (Poland) (Chirp3-HD-Despina Female)',
  'pl-PL-Chirp3-HD-Enceladus' = 'Polish (Poland) (Chirp3-HD-Enceladus Male)',
  'pl-PL-Chirp3-HD-Erinome' = 'Polish (Poland) (Chirp3-HD-Erinome Female)',
  'pl-PL-Chirp3-HD-Fenrir' = 'Polish (Poland) (Chirp3-HD-Fenrir Male)',
  'pl-PL-Chirp3-HD-Gacrux' = 'Polish (Poland) (Chirp3-HD-Gacrux Female)',
  'pl-PL-Chirp3-HD-Iapetus' = 'Polish (Poland) (Chirp3-HD-Iapetus Male)',
  'pl-PL-Chirp3-HD-Kore' = 'Polish (Poland) (Chirp3-HD-Kore Female)',
  'pl-PL-Chirp3-HD-Laomedeia' = 'Polish (Poland) (Chirp3-HD-Laomedeia Female)',
  'pl-PL-Chirp3-HD-Leda' = 'Polish (Poland) (Chirp3-HD-Leda Female)',
  'pl-PL-Chirp3-HD-Orus' = 'Polish (Poland) (Chirp3-HD-Orus Male)',
  'pl-PL-Chirp3-HD-Puck' = 'Polish (Poland) (Chirp3-HD-Puck Male)',
  'pl-PL-Chirp3-HD-Pulcherrima' = 'Polish (Poland) (Chirp3-HD-Pulcherrima Female)',
  'pl-PL-Chirp3-HD-Rasalgethi' = 'Polish (Poland) (Chirp3-HD-Rasalgethi Male)',
  'pl-PL-Chirp3-HD-Sadachbia' = 'Polish (Poland) (Chirp3-HD-Sadachbia Male)',
  'pl-PL-Chirp3-HD-Sadaltager' = 'Polish (Poland) (Chirp3-HD-Sadaltager Male)',
  'pl-PL-Chirp3-HD-Schedar' = 'Polish (Poland) (Chirp3-HD-Schedar Male)',
  'pl-PL-Chirp3-HD-Sulafat' = 'Polish (Poland) (Chirp3-HD-Sulafat Female)',
  'pl-PL-Chirp3-HD-Umbriel' = 'Polish (Poland) (Chirp3-HD-Umbriel Male)',
  'pl-PL-Chirp3-HD-Vindemiatrix' = 'Polish (Poland) (Chirp3-HD-Vindemiatrix Female)',
  'pl-PL-Chirp3-HD-Zephyr' = 'Polish (Poland) (Chirp3-HD-Zephyr Female)',
  'pl-PL-Chirp3-HD-Zubenelgenubi' = 'Polish (Poland) (Chirp3-HD-Zubenelgenubi Male)',
  'pl-PL-Standard-F' = 'Polish (Poland) (Standard-F Female)',
  'pl-PL-Standard-G' = 'Polish (Poland) (Standard-G Male)',
  'pl-PL-Wavenet-F' = 'Polish (Poland) (Wavenet-F Female)',
  'pl-PL-Wavenet-G' = 'Polish (Poland) (Wavenet-G Male)',
  'pt-BR-Chirp3-HD-Achernar' = 'Portuguese (Brazil) (Chirp3-HD-Achernar Female)',
  'pt-BR-Chirp3-HD-Achird' = 'Portuguese (Brazil) (Chirp3-HD-Achird Male)',
  'pt-BR-Chirp3-HD-Algenib' = 'Portuguese (Brazil) (Chirp3-HD-Algenib Male)',
  'pt-BR-Chirp3-HD-Algieba' = 'Portuguese (Brazil) (Chirp3-HD-Algieba Male)',
  'pt-BR-Chirp3-HD-Alnilam' = 'Portuguese (Brazil) (Chirp3-HD-Alnilam Male)',
  'pt-BR-Chirp3-HD-Aoede' = 'Portuguese (Brazil) (Chirp3-HD-Aoede Female)',
  'pt-BR-Chirp3-HD-Autonoe' = 'Portuguese (Brazil) (Chirp3-HD-Autonoe Female)',
  'pt-BR-Chirp3-HD-Callirrhoe' = 'Portuguese (Brazil) (Chirp3-HD-Callirrhoe Female)',
  'pt-BR-Chirp3-HD-Charon' = 'Portuguese (Brazil) (Chirp3-HD-Charon Male)',
  'pt-BR-Chirp3-HD-Despina' = 'Portuguese (Brazil) (Chirp3-HD-Despina Female)',
  'pt-BR-Chirp3-HD-Enceladus' = 'Portuguese (Brazil) (Chirp3-HD-Enceladus Male)',
  'pt-BR-Chirp3-HD-Erinome' = 'Portuguese (Brazil) (Chirp3-HD-Erinome Female)',
  'pt-BR-Chirp3-HD-Fenrir' = 'Portuguese (Brazil) (Chirp3-HD-Fenrir Male)',
  'pt-BR-Chirp3-HD-Gacrux' = 'Portuguese (Brazil) (Chirp3-HD-Gacrux Female)',
  'pt-BR-Chirp3-HD-Iapetus' = 'Portuguese (Brazil) (Chirp3-HD-Iapetus Male)',
  'pt-BR-Chirp3-HD-Kore' = 'Portuguese (Brazil) (Chirp3-HD-Kore Female)',
  'pt-BR-Chirp3-HD-Laomedeia' = 'Portuguese (Brazil) (Chirp3-HD-Laomedeia Female)',
  'pt-BR-Chirp3-HD-Leda' = 'Portuguese (Brazil) (Chirp3-HD-Leda Female)',
  'pt-BR-Chirp3-HD-Orus' = 'Portuguese (Brazil) (Chirp3-HD-Orus Male)',
  'pt-BR-Chirp3-HD-Puck' = 'Portuguese (Brazil) (Chirp3-HD-Puck Male)',
  'pt-BR-Chirp3-HD-Pulcherrima' = 'Portuguese (Brazil) (Chirp3-HD-Pulcherrima Female)',
  'pt-BR-Chirp3-HD-Rasalgethi' = 'Portuguese (Brazil) (Chirp3-HD-Rasalgethi Male)',
  'pt-BR-Chirp3-HD-Sadachbia' = 'Portuguese (Brazil) (Chirp3-HD-Sadachbia Male)',
  'pt-BR-Chirp3-HD-Sadaltager' = 'Portuguese (Brazil) (Chirp3-HD-Sadaltager Male)',
  'pt-BR-Chirp3-HD-Schedar' = 'Portuguese (Brazil) (Chirp3-HD-Schedar Male)',
  'pt-BR-Chirp3-HD-Sulafat' = 'Portuguese (Brazil) (Chirp3-HD-Sulafat Female)',
  'pt-BR-Chirp3-HD-Umbriel' = 'Portuguese (Brazil) (Chirp3-HD-Umbriel Male)',
  'pt-BR-Chirp3-HD-Vindemiatrix' = 'Portuguese (Brazil) (Chirp3-HD-Vindemiatrix Female)',
  'pt-BR-Chirp3-HD-Zephyr' = 'Portuguese (Brazil) (Chirp3-HD-Zephyr Female)',
  'pt-BR-Chirp3-HD-Zubenelgenubi' = 'Portuguese (Brazil) (Chirp3-HD-Zubenelgenubi Male)',
  'pt-BR-Neural2-A' = 'Portuguese (Brazil) (Neural2-A Female)',
  'pt-BR-Neural2-B' = 'Portuguese (Brazil) (Neural2-B Male)',
  'pt-BR-Neural2-C' = 'Portuguese (Brazil) (Neural2-C Female)',
  'pt-BR-Standard-A' = 'Portuguese (Brazil) (Standard-A Female)',
  'pt-BR-Standard-B' = 'Portuguese (Brazil) (Standard-B Male)',
  'pt-BR-Standard-C' = 'Portuguese (Brazil) (Standard-C Female)',
  'pt-BR-Standard-D' = 'Portuguese (Brazil) (Standard-D Female)',
  'pt-BR-Standard-E' = 'Portuguese (Brazil) (Standard-E Male)',
  'pt-BR-Wavenet-A' = 'Portuguese (Brazil) (Wavenet-A Female)',
  'pt-BR-Wavenet-B' = 'Portuguese (Brazil) (Wavenet-B Male)',
  'pt-BR-Wavenet-C' = 'Portuguese (Brazil) (Wavenet-C Female)',
  'pt-BR-Wavenet-D' = 'Portuguese (Brazil) (Wavenet-D Female)',
  'pt-BR-Wavenet-E' = 'Portuguese (Brazil) (Wavenet-E Male)',
  'pt-PT-Standard-E' = 'Portuguese (Portugal) (Standard-E Female)',
  'pt-PT-Standard-F' = 'Portuguese (Portugal) (Standard-F Male)',
  'pt-PT-Wavenet-E' = 'Portuguese (Portugal) (Wavenet-E Female)',
  'pt-PT-Wavenet-F' = 'Portuguese (Portugal) (Wavenet-F Male)',
  'pa-IN-Standard-A' = 'Punjabi (India) (Standard-A Female)',
  'pa-IN-Standard-B' = 'Punjabi (India) (Standard-B Male)',
  'pa-IN-Standard-C' = 'Punjabi (India) (Standard-C Female)',
  'pa-IN-Standard-D' = 'Punjabi (India) (Standard-D Male)',
  'pa-IN-Wavenet-A' = 'Punjabi (India) (Wavenet-A Female)',
  'pa-IN-Wavenet-B' = 'Punjabi (India) (Wavenet-B Male)',
  'pa-IN-Wavenet-C' = 'Punjabi (India) (Wavenet-C Female)',
  'pa-IN-Wavenet-D' = 'Punjabi (India) (Wavenet-D Male)',
  'ro-RO-Standard-B' = 'Romanian (Romania) (Standard-B Female)',
  'ro-RO-Wavenet-B' = 'Romanian (Romania) (Wavenet-B Female)',
  'ru-RU-Chirp3-HD-Aoede' = 'Russian (Russia) (Chirp3-HD-Aoede Female)',
  'ru-RU-Chirp3-HD-Charon' = 'Russian (Russia) (Chirp3-HD-Charon Male)',
  'ru-RU-Chirp3-HD-Fenrir' = 'Russian (Russia) (Chirp3-HD-Fenrir Male)',
  'ru-RU-Chirp3-HD-Kore' = 'Russian (Russia) (Chirp3-HD-Kore Female)',
  'ru-RU-Chirp3-HD-Leda' = 'Russian (Russia) (Chirp3-HD-Leda Female)',
  'ru-RU-Chirp3-HD-Orus' = 'Russian (Russia) (Chirp3-HD-Orus Male)',
  'ru-RU-Chirp3-HD-Puck' = 'Russian (Russia) (Chirp3-HD-Puck Male)',
  'ru-RU-Chirp3-HD-Zephyr' = 'Russian (Russia) (Chirp3-HD-Zephyr Female)',
  'ru-RU-Standard-A' = 'Russian (Russia) (Standard-A Female)',
  'ru-RU-Standard-B' = 'Russian (Russia) (Standard-B Male)',
  'ru-RU-Standard-C' = 'Russian (Russia) (Standard-C Female)',
  'ru-RU-Standard-D' = 'Russian (Russia) (Standard-D Male)',
  'ru-RU-Standard-E' = 'Russian (Russia) (Standard-E Female)',
  'ru-RU-Wavenet-A' = 'Russian (Russia) (Wavenet-A Female)',
  'ru-RU-Wavenet-B' = 'Russian (Russia) (Wavenet-B Male)',
  'ru-RU-Wavenet-C' = 'Russian (Russia) (Wavenet-C Female)',
  'ru-RU-Wavenet-D' = 'Russian (Russia) (Wavenet-D Male)',
  'ru-RU-Wavenet-E' = 'Russian (Russia) (Wavenet-E Female)',
  'sr-RS-Standard-B' = 'Serbian (Cyrillic) (Standard-B Female)',
  'sk-SK-Standard-B' = 'Slovak (Slovakia) (Standard-B Female)',
  'sk-SK-Wavenet-B' = 'Slovak (Slovakia) (Wavenet-B Female)',
  'es-ES-Chirp-HD-D' = 'Spanish (Spain) (Chirp-HD-D Male)',
  'es-ES-Chirp-HD-F' = 'Spanish (Spain) (Chirp-HD-F Female)',
  'es-ES-Chirp-HD-O' = 'Spanish (Spain) (Chirp-HD-O Female)',
  'es-ES-Chirp3-HD-Achernar' = 'Spanish (Spain) (Chirp3-HD-Achernar Female)',
  'es-ES-Chirp3-HD-Achird' = 'Spanish (Spain) (Chirp3-HD-Achird Male)',
  'es-ES-Chirp3-HD-Algenib' = 'Spanish (Spain) (Chirp3-HD-Algenib Male)',
  'es-ES-Chirp3-HD-Algieba' = 'Spanish (Spain) (Chirp3-HD-Algieba Male)',
  'es-ES-Chirp3-HD-Alnilam' = 'Spanish (Spain) (Chirp3-HD-Alnilam Male)',
  'es-ES-Chirp3-HD-Aoede' = 'Spanish (Spain) (Chirp3-HD-Aoede Female)',
  'es-ES-Chirp3-HD-Autonoe' = 'Spanish (Spain) (Chirp3-HD-Autonoe Female)',
  'es-ES-Chirp3-HD-Callirrhoe' = 'Spanish (Spain) (Chirp3-HD-Callirrhoe Female)',
  'es-ES-Chirp3-HD-Charon' = 'Spanish (Spain) (Chirp3-HD-Charon Male)',
  'es-ES-Chirp3-HD-Despina' = 'Spanish (Spain) (Chirp3-HD-Despina Female)',
  'es-ES-Chirp3-HD-Enceladus' = 'Spanish (Spain) (Chirp3-HD-Enceladus Male)',
  'es-ES-Chirp3-HD-Erinome' = 'Spanish (Spain) (Chirp3-HD-Erinome Female)',
  'es-ES-Chirp3-HD-Fenrir' = 'Spanish (Spain) (Chirp3-HD-Fenrir Male)',
  'es-ES-Chirp3-HD-Gacrux' = 'Spanish (Spain) (Chirp3-HD-Gacrux Female)',
  'es-ES-Chirp3-HD-Iapetus' = 'Spanish (Spain) (Chirp3-HD-Iapetus Male)',
  'es-ES-Chirp3-HD-Kore' = 'Spanish (Spain) (Chirp3-HD-Kore Female)',
  'es-ES-Chirp3-HD-Laomedeia' = 'Spanish (Spain) (Chirp3-HD-Laomedeia Female)',
  'es-ES-Chirp3-HD-Leda' = 'Spanish (Spain) (Chirp3-HD-Leda Female)',
  'es-ES-Chirp3-HD-Orus' = 'Spanish (Spain) (Chirp3-HD-Orus Male)',
  'es-ES-Chirp3-HD-Puck' = 'Spanish (Spain) (Chirp3-HD-Puck Male)',
  'es-ES-Chirp3-HD-Pulcherrima' = 'Spanish (Spain) (Chirp3-HD-Pulcherrima Female)',
  'es-ES-Chirp3-HD-Rasalgethi' = 'Spanish (Spain) (Chirp3-HD-Rasalgethi Male)',
  'es-ES-Chirp3-HD-Sadachbia' = 'Spanish (Spain) (Chirp3-HD-Sadachbia Male)',
  'es-ES-Chirp3-HD-Sadaltager' = 'Spanish (Spain) (Chirp3-HD-Sadaltager Male)',
  'es-ES-Chirp3-HD-Schedar' = 'Spanish (Spain) (Chirp3-HD-Schedar Male)',
  'es-ES-Chirp3-HD-Sulafat' = 'Spanish (Spain) (Chirp3-HD-Sulafat Female)',
  'es-ES-Chirp3-HD-Umbriel' = 'Spanish (Spain) (Chirp3-HD-Umbriel Male)',
  'es-ES-Chirp3-HD-Vindemiatrix' = 'Spanish (Spain) (Chirp3-HD-Vindemiatrix Female)',
  'es-ES-Chirp3-HD-Zephyr' = 'Spanish (Spain) (Chirp3-HD-Zephyr Female)',
  'es-ES-Chirp3-HD-Zubenelgenubi' = 'Spanish (Spain) (Chirp3-HD-Zubenelgenubi Male)',
  'es-ES-Neural2-A' = 'Spanish (Spain) (Neural2-A Female)',
  'es-ES-Neural2-E' = 'Spanish (Spain) (Neural2-E Female)',
  'es-ES-Neural2-F' = 'Spanish (Spain) (Neural2-F Male)',
  'es-ES-Neural2-G' = 'Spanish (Spain) (Neural2-G Male)',
  'es-ES-Neural2-H' = 'Spanish (Spain) (Neural2-H Female)',
  'es-ES-Polyglot-1' = 'Spanish (Spain) (Polyglot-1 Male)',
  'es-ES-Standard-E' = 'Spanish (Spain) (Standard-E Male)',
  'es-ES-Standard-F' = 'Spanish (Spain) (Standard-F Female)',
  'es-ES-Standard-G' = 'Spanish (Spain) (Standard-G Male)',
  'es-ES-Standard-H' = 'Spanish (Spain) (Standard-H Female)',
  'es-ES-Studio-C' = 'Spanish (Spain) (Studio-C Female)',
  'es-ES-Studio-F' = 'Spanish (Spain) (Studio-F Male)',
  'es-ES-Wavenet-E' = 'Spanish (Spain) (Wavenet-E Male)',
  'es-ES-Wavenet-F' = 'Spanish (Spain) (Wavenet-F Female)',
  'es-ES-Wavenet-G' = 'Spanish (Spain) (Wavenet-G Male)',
  'es-ES-Wavenet-H' = 'Spanish (Spain) (Wavenet-H Female)',
  'es-US-Chirp-HD-D' = 'Spanish (US) (Chirp-HD-D Male)',
  'es-US-Chirp-HD-F' = 'Spanish (US) (Chirp-HD-F Female)',
  'es-US-Chirp-HD-O' = 'Spanish (US) (Chirp-HD-O Female)',
  'es-US-Chirp3-HD-Achernar' = 'Spanish (US) (Chirp3-HD-Achernar Female)',
  'es-US-Chirp3-HD-Achird' = 'Spanish (US) (Chirp3-HD-Achird Male)',
  'es-US-Chirp3-HD-Algenib' = 'Spanish (US) (Chirp3-HD-Algenib Male)',
  'es-US-Chirp3-HD-Algieba' = 'Spanish (US) (Chirp3-HD-Algieba Male)',
  'es-US-Chirp3-HD-Alnilam' = 'Spanish (US) (Chirp3-HD-Alnilam Male)',
  'es-US-Chirp3-HD-Aoede' = 'Spanish (US) (Chirp3-HD-Aoede Female)',
  'es-US-Chirp3-HD-Autonoe' = 'Spanish (US) (Chirp3-HD-Autonoe Female)',
  'es-US-Chirp3-HD-Callirrhoe' = 'Spanish (US) (Chirp3-HD-Callirrhoe Female)',
  'es-US-Chirp3-HD-Charon' = 'Spanish (US) (Chirp3-HD-Charon Male)',
  'es-US-Chirp3-HD-Despina' = 'Spanish (US) (Chirp3-HD-Despina Female)',
  'es-US-Chirp3-HD-Enceladus' = 'Spanish (US) (Chirp3-HD-Enceladus Male)',
  'es-US-Chirp3-HD-Erinome' = 'Spanish (US) (Chirp3-HD-Erinome Female)',
  'es-US-Chirp3-HD-Fenrir' = 'Spanish (US) (Chirp3-HD-Fenrir Male)',
  'es-US-Chirp3-HD-Gacrux' = 'Spanish (US) (Chirp3-HD-Gacrux Female)',
  'es-US-Chirp3-HD-Iapetus' = 'Spanish (US) (Chirp3-HD-Iapetus Male)',
  'es-US-Chirp3-HD-Kore' = 'Spanish (US) (Chirp3-HD-Kore Female)',
  'es-US-Chirp3-HD-Laomedeia' = 'Spanish (US) (Chirp3-HD-Laomedeia Female)',
  'es-US-Chirp3-HD-Leda' = 'Spanish (US) (Chirp3-HD-Leda Female)',
  'es-US-Chirp3-HD-Orus' = 'Spanish (US) (Chirp3-HD-Orus Male)',
  'es-US-Chirp3-HD-Puck' = 'Spanish (US) (Chirp3-HD-Puck Male)',
  'es-US-Chirp3-HD-Pulcherrima' = 'Spanish (US) (Chirp3-HD-Pulcherrima Female)',
  'es-US-Chirp3-HD-Rasalgethi' = 'Spanish (US) (Chirp3-HD-Rasalgethi Male)',
  'es-US-Chirp3-HD-Sadachbia' = 'Spanish (US) (Chirp3-HD-Sadachbia Male)',
  'es-US-Chirp3-HD-Sadaltager' = 'Spanish (US) (Chirp3-HD-Sadaltager Male)',
  'es-US-Chirp3-HD-Schedar' = 'Spanish (US) (Chirp3-HD-Schedar Male)',
  'es-US-Chirp3-HD-Sulafat' = 'Spanish (US) (Chirp3-HD-Sulafat Female)',
  'es-US-Chirp3-HD-Umbriel' = 'Spanish (US) (Chirp3-HD-Umbriel Male)',
  'es-US-Chirp3-HD-Vindemiatrix' = 'Spanish (US) (Chirp3-HD-Vindemiatrix Female)',
  'es-US-Chirp3-HD-Zephyr' = 'Spanish (US) (Chirp3-HD-Zephyr Female)',
  'es-US-Chirp3-HD-Zubenelgenubi' = 'Spanish (US) (Chirp3-HD-Zubenelgenubi Male)',
  'es-US-Neural2-A' = 'Spanish (US) (Neural2-A Female)',
  'es-US-Neural2-B' = 'Spanish (US) (Neural2-B Male)',
  'es-US-Neural2-C' = 'Spanish (US) (Neural2-C Male)',
  'es-US-News-D' = 'Spanish (US) (News-D Male)',
  'es-US-News-E' = 'Spanish (US) (News-E Male)',
  'es-US-News-F' = 'Spanish (US) (News-F Female)',
  'es-US-News-G' = 'Spanish (US) (News-G Female)',
  'es-US-Polyglot-1' = 'Spanish (US) (Polyglot-1 Male)',
  'es-US-Standard-A' = 'Spanish (US) (Standard-A Female)',
  'es-US-Standard-B' = 'Spanish (US) (Standard-B Male)',
  'es-US-Standard-C' = 'Spanish (US) (Standard-C Male)',
  'es-US-Studio-B' = 'Spanish (US) (Studio-B Male)',
  'es-US-Wavenet-A' = 'Spanish (US) (Wavenet-A Female)',
  'es-US-Wavenet-B' = 'Spanish (US) (Wavenet-B Male)',
  'es-US-Wavenet-C' = 'Spanish (US) (Wavenet-C Male)',
  'sv-SE-Standard-A' = 'Swedish (Sweden) (Standard-A Female)',
  'sv-SE-Standard-B' = 'Swedish (Sweden) (Standard-B Female)',
  'sv-SE-Standard-C' = 'Swedish (Sweden) (Standard-C Female)',
  'sv-SE-Standard-D' = 'Swedish (Sweden) (Standard-D Male)',
  'sv-SE-Standard-E' = 'Swedish (Sweden) (Standard-E Male)',
  'sv-SE-Standard-F' = 'Swedish (Sweden) (Standard-F Female)',
  'sv-SE-Standard-G' = 'Swedish (Sweden) (Standard-G Male)',
  'sv-SE-Wavenet-A' = 'Swedish (Sweden) (Wavenet-A Female)',
  'sv-SE-Wavenet-B' = 'Swedish (Sweden) (Wavenet-B Female)',
  'sv-SE-Wavenet-C' = 'Swedish (Sweden) (Wavenet-C Male)',
  'sv-SE-Wavenet-D' = 'Swedish (Sweden) (Wavenet-D Female)',
  'sv-SE-Wavenet-E' = 'Swedish (Sweden) (Wavenet-E Male)',
  'sv-SE-Wavenet-F' = 'Swedish (Sweden) (Wavenet-F Female)',
  'sv-SE-Wavenet-G' = 'Swedish (Sweden) (Wavenet-G Male)',
  'ta-IN-Chirp3-HD-Achernar' = 'Tamil (India) (Chirp3-HD-Achernar Female)',
  'ta-IN-Chirp3-HD-Achird' = 'Tamil (India) (Chirp3-HD-Achird Male)',
  'ta-IN-Chirp3-HD-Algenib' = 'Tamil (India) (Chirp3-HD-Algenib Male)',
  'ta-IN-Chirp3-HD-Algieba' = 'Tamil (India) (Chirp3-HD-Algieba Male)',
  'ta-IN-Chirp3-HD-Alnilam' = 'Tamil (India) (Chirp3-HD-Alnilam Male)',
  'ta-IN-Chirp3-HD-Aoede' = 'Tamil (India) (Chirp3-HD-Aoede Female)',
  'ta-IN-Chirp3-HD-Autonoe' = 'Tamil (India) (Chirp3-HD-Autonoe Female)',
  'ta-IN-Chirp3-HD-Callirrhoe' = 'Tamil (India) (Chirp3-HD-Callirrhoe Female)',
  'ta-IN-Chirp3-HD-Charon' = 'Tamil (India) (Chirp3-HD-Charon Male)',
  'ta-IN-Chirp3-HD-Despina' = 'Tamil (India) (Chirp3-HD-Despina Female)',
  'ta-IN-Chirp3-HD-Enceladus' = 'Tamil (India) (Chirp3-HD-Enceladus Male)',
  'ta-IN-Chirp3-HD-Erinome' = 'Tamil (India) (Chirp3-HD-Erinome Female)',
  'ta-IN-Chirp3-HD-Fenrir' = 'Tamil (India) (Chirp3-HD-Fenrir Male)',
  'ta-IN-Chirp3-HD-Gacrux' = 'Tamil (India) (Chirp3-HD-Gacrux Female)',
  'ta-IN-Chirp3-HD-Iapetus' = 'Tamil (India) (Chirp3-HD-Iapetus Male)',
  'ta-IN-Chirp3-HD-Kore' = 'Tamil (India) (Chirp3-HD-Kore Female)',
  'ta-IN-Chirp3-HD-Laomedeia' = 'Tamil (India) (Chirp3-HD-Laomedeia Female)',
  'ta-IN-Chirp3-HD-Leda' = 'Tamil (India) (Chirp3-HD-Leda Female)',
  'ta-IN-Chirp3-HD-Orus' = 'Tamil (India) (Chirp3-HD-Orus Male)',
  'ta-IN-Chirp3-HD-Puck' = 'Tamil (India) (Chirp3-HD-Puck Male)',
  'ta-IN-Chirp3-HD-Pulcherrima' = 'Tamil (India) (Chirp3-HD-Pulcherrima Female)',
  'ta-IN-Chirp3-HD-Rasalgethi' = 'Tamil (India) (Chirp3-HD-Rasalgethi Male)',
  'ta-IN-Chirp3-HD-Sadachbia' = 'Tamil (India) (Chirp3-HD-Sadachbia Male)',
  'ta-IN-Chirp3-HD-Sadaltager' = 'Tamil (India) (Chirp3-HD-Sadaltager Male)',
  'ta-IN-Chirp3-HD-Schedar' = 'Tamil (India) (Chirp3-HD-Schedar Male)',
  'ta-IN-Chirp3-HD-Sulafat' = 'Tamil (India) (Chirp3-HD-Sulafat Female)',
  'ta-IN-Chirp3-HD-Umbriel' = 'Tamil (India) (Chirp3-HD-Umbriel Male)',
  'ta-IN-Chirp3-HD-Vindemiatrix' = 'Tamil (India) (Chirp3-HD-Vindemiatrix Female)',
  'ta-IN-Chirp3-HD-Zephyr' = 'Tamil (India) (Chirp3-HD-Zephyr Female)',
  'ta-IN-Chirp3-HD-Zubenelgenubi' = 'Tamil (India) (Chirp3-HD-Zubenelgenubi Male)',
  'ta-IN-Standard-A' = 'Tamil (India) (Standard-A Female)',
  'ta-IN-Standard-B' = 'Tamil (India) (Standard-B Male)',
  'ta-IN-Standard-C' = 'Tamil (India) (Standard-C Female)',
  'ta-IN-Standard-D' = 'Tamil (India) (Standard-D Male)',
  'ta-IN-Wavenet-A' = 'Tamil (India) (Wavenet-A Female)',
  'ta-IN-Wavenet-B' = 'Tamil (India) (Wavenet-B Male)',
  'ta-IN-Wavenet-C' = 'Tamil (India) (Wavenet-C Female)',
  'ta-IN-Wavenet-D' = 'Tamil (India) (Wavenet-D Male)',
  'te-IN-Chirp3-HD-Achernar' = 'Telugu (India) (Chirp3-HD-Achernar Female)',
  'te-IN-Chirp3-HD-Achird' = 'Telugu (India) (Chirp3-HD-Achird Male)',
  'te-IN-Chirp3-HD-Algenib' = 'Telugu (India) (Chirp3-HD-Algenib Male)',
  'te-IN-Chirp3-HD-Algieba' = 'Telugu (India) (Chirp3-HD-Algieba Male)',
  'te-IN-Chirp3-HD-Alnilam' = 'Telugu (India) (Chirp3-HD-Alnilam Male)',
  'te-IN-Chirp3-HD-Aoede' = 'Telugu (India) (Chirp3-HD-Aoede Female)',
  'te-IN-Chirp3-HD-Autonoe' = 'Telugu (India) (Chirp3-HD-Autonoe Female)',
  'te-IN-Chirp3-HD-Callirrhoe' = 'Telugu (India) (Chirp3-HD-Callirrhoe Female)',
  'te-IN-Chirp3-HD-Charon' = 'Telugu (India) (Chirp3-HD-Charon Male)',
  'te-IN-Chirp3-HD-Despina' = 'Telugu (India) (Chirp3-HD-Despina Female)',
  'te-IN-Chirp3-HD-Enceladus' = 'Telugu (India) (Chirp3-HD-Enceladus Male)',
  'te-IN-Chirp3-HD-Erinome' = 'Telugu (India) (Chirp3-HD-Erinome Female)',
  'te-IN-Chirp3-HD-Fenrir' = 'Telugu (India) (Chirp3-HD-Fenrir Male)',
  'te-IN-Chirp3-HD-Gacrux' = 'Telugu (India) (Chirp3-HD-Gacrux Female)',
  'te-IN-Chirp3-HD-Iapetus' = 'Telugu (India) (Chirp3-HD-Iapetus Male)',
  'te-IN-Chirp3-HD-Kore' = 'Telugu (India) (Chirp3-HD-Kore Female)',
  'te-IN-Chirp3-HD-Laomedeia' = 'Telugu (India) (Chirp3-HD-Laomedeia Female)',
  'te-IN-Chirp3-HD-Leda' = 'Telugu (India) (Chirp3-HD-Leda Female)',
  'te-IN-Chirp3-HD-Orus' = 'Telugu (India) (Chirp3-HD-Orus Male)',
  'te-IN-Chirp3-HD-Puck' = 'Telugu (India) (Chirp3-HD-Puck Male)',
  'te-IN-Chirp3-HD-Pulcherrima' = 'Telugu (India) (Chirp3-HD-Pulcherrima Female)',
  'te-IN-Chirp3-HD-Rasalgethi' = 'Telugu (India) (Chirp3-HD-Rasalgethi Male)',
  'te-IN-Chirp3-HD-Sadachbia' = 'Telugu (India) (Chirp3-HD-Sadachbia Male)',
  'te-IN-Chirp3-HD-Sadaltager' = 'Telugu (India) (Chirp3-HD-Sadaltager Male)',
  'te-IN-Chirp3-HD-Schedar' = 'Telugu (India) (Chirp3-HD-Schedar Male)',
  'te-IN-Chirp3-HD-Sulafat' = 'Telugu (India) (Chirp3-HD-Sulafat Female)',
  'te-IN-Chirp3-HD-Umbriel' = 'Telugu (India) (Chirp3-HD-Umbriel Male)',
  'te-IN-Chirp3-HD-Vindemiatrix' = 'Telugu (India) (Chirp3-HD-Vindemiatrix Female)',
  'te-IN-Chirp3-HD-Zephyr' = 'Telugu (India) (Chirp3-HD-Zephyr Female)',
  'te-IN-Chirp3-HD-Zubenelgenubi' = 'Telugu (India) (Chirp3-HD-Zubenelgenubi Male)',
  'te-IN-Standard-A' = 'Telugu (India) (Standard-A Female)',
  'te-IN-Standard-B' = 'Telugu (India) (Standard-B Male)',
  'te-IN-Standard-C' = 'Telugu (India) (Standard-C Female)',
  'te-IN-Standard-D' = 'Telugu (India) (Standard-D Male)',
  'th-TH-Chirp3-HD-Achernar' = 'Thai (Thailand) (Chirp3-HD-Achernar Female)',
  'th-TH-Chirp3-HD-Achird' = 'Thai (Thailand) (Chirp3-HD-Achird Male)',
  'th-TH-Chirp3-HD-Algenib' = 'Thai (Thailand) (Chirp3-HD-Algenib Male)',
  'th-TH-Chirp3-HD-Algieba' = 'Thai (Thailand) (Chirp3-HD-Algieba Male)',
  'th-TH-Chirp3-HD-Alnilam' = 'Thai (Thailand) (Chirp3-HD-Alnilam Male)',
  'th-TH-Chirp3-HD-Aoede' = 'Thai (Thailand) (Chirp3-HD-Aoede Female)',
  'th-TH-Chirp3-HD-Autonoe' = 'Thai (Thailand) (Chirp3-HD-Autonoe Female)',
  'th-TH-Chirp3-HD-Callirrhoe' = 'Thai (Thailand) (Chirp3-HD-Callirrhoe Female)',
  'th-TH-Chirp3-HD-Charon' = 'Thai (Thailand) (Chirp3-HD-Charon Male)',
  'th-TH-Chirp3-HD-Despina' = 'Thai (Thailand) (Chirp3-HD-Despina Female)',
  'th-TH-Chirp3-HD-Enceladus' = 'Thai (Thailand) (Chirp3-HD-Enceladus Male)',
  'th-TH-Chirp3-HD-Erinome' = 'Thai (Thailand) (Chirp3-HD-Erinome Female)',
  'th-TH-Chirp3-HD-Fenrir' = 'Thai (Thailand) (Chirp3-HD-Fenrir Male)',
  'th-TH-Chirp3-HD-Gacrux' = 'Thai (Thailand) (Chirp3-HD-Gacrux Female)',
  'th-TH-Chirp3-HD-Iapetus' = 'Thai (Thailand) (Chirp3-HD-Iapetus Male)',
  'th-TH-Chirp3-HD-Kore' = 'Thai (Thailand) (Chirp3-HD-Kore Female)',
  'th-TH-Chirp3-HD-Laomedeia' = 'Thai (Thailand) (Chirp3-HD-Laomedeia Female)',
  'th-TH-Chirp3-HD-Leda' = 'Thai (Thailand) (Chirp3-HD-Leda Female)',
  'th-TH-Chirp3-HD-Orus' = 'Thai (Thailand) (Chirp3-HD-Orus Male)',
  'th-TH-Chirp3-HD-Puck' = 'Thai (Thailand) (Chirp3-HD-Puck Male)',
  'th-TH-Chirp3-HD-Pulcherrima' = 'Thai (Thailand) (Chirp3-HD-Pulcherrima Female)',
  'th-TH-Chirp3-HD-Rasalgethi' = 'Thai (Thailand) (Chirp3-HD-Rasalgethi Male)',
  'th-TH-Chirp3-HD-Sadachbia' = 'Thai (Thailand) (Chirp3-HD-Sadachbia Male)',
  'th-TH-Chirp3-HD-Sadaltager' = 'Thai (Thailand) (Chirp3-HD-Sadaltager Male)',
  'th-TH-Chirp3-HD-Schedar' = 'Thai (Thailand) (Chirp3-HD-Schedar Male)',
  'th-TH-Chirp3-HD-Sulafat' = 'Thai (Thailand) (Chirp3-HD-Sulafat Female)',
  'th-TH-Chirp3-HD-Umbriel' = 'Thai (Thailand) (Chirp3-HD-Umbriel Male)',
  'th-TH-Chirp3-HD-Vindemiatrix' = 'Thai (Thailand) (Chirp3-HD-Vindemiatrix Female)',
  'th-TH-Chirp3-HD-Zephyr' = 'Thai (Thailand) (Chirp3-HD-Zephyr Female)',
  'th-TH-Chirp3-HD-Zubenelgenubi' = 'Thai (Thailand) (Chirp3-HD-Zubenelgenubi Male)',
  'th-TH-Neural2-C' = 'Thai (Thailand) (Neural2-C Female)',
  'th-TH-Standard-A' = 'Thai (Thailand) (Standard-A Female)',
  'tr-TR-Chirp3-HD-Achernar' = 'Turkish (Turkey) (Chirp3-HD-Achernar Female)',
  'tr-TR-Chirp3-HD-Achird' = 'Turkish (Turkey) (Chirp3-HD-Achird Male)',
  'tr-TR-Chirp3-HD-Algenib' = 'Turkish (Turkey) (Chirp3-HD-Algenib Male)',
  'tr-TR-Chirp3-HD-Algieba' = 'Turkish (Turkey) (Chirp3-HD-Algieba Male)',
  'tr-TR-Chirp3-HD-Alnilam' = 'Turkish (Turkey) (Chirp3-HD-Alnilam Male)',
  'tr-TR-Chirp3-HD-Aoede' = 'Turkish (Turkey) (Chirp3-HD-Aoede Female)',
  'tr-TR-Chirp3-HD-Autonoe' = 'Turkish (Turkey) (Chirp3-HD-Autonoe Female)',
  'tr-TR-Chirp3-HD-Callirrhoe' = 'Turkish (Turkey) (Chirp3-HD-Callirrhoe Female)',
  'tr-TR-Chirp3-HD-Charon' = 'Turkish (Turkey) (Chirp3-HD-Charon Male)',
  'tr-TR-Chirp3-HD-Despina' = 'Turkish (Turkey) (Chirp3-HD-Despina Female)',
  'tr-TR-Chirp3-HD-Enceladus' = 'Turkish (Turkey) (Chirp3-HD-Enceladus Male)',
  'tr-TR-Chirp3-HD-Erinome' = 'Turkish (Turkey) (Chirp3-HD-Erinome Female)',
  'tr-TR-Chirp3-HD-Fenrir' = 'Turkish (Turkey) (Chirp3-HD-Fenrir Male)',
  'tr-TR-Chirp3-HD-Gacrux' = 'Turkish (Turkey) (Chirp3-HD-Gacrux Female)',
  'tr-TR-Chirp3-HD-Iapetus' = 'Turkish (Turkey) (Chirp3-HD-Iapetus Male)',
  'tr-TR-Chirp3-HD-Kore' = 'Turkish (Turkey) (Chirp3-HD-Kore Female)',
  'tr-TR-Chirp3-HD-Laomedeia' = 'Turkish (Turkey) (Chirp3-HD-Laomedeia Female)',
  'tr-TR-Chirp3-HD-Leda' = 'Turkish (Turkey) (Chirp3-HD-Leda Female)',
  'tr-TR-Chirp3-HD-Orus' = 'Turkish (Turkey) (Chirp3-HD-Orus Male)',
  'tr-TR-Chirp3-HD-Puck' = 'Turkish (Turkey) (Chirp3-HD-Puck Male)',
  'tr-TR-Chirp3-HD-Pulcherrima' = 'Turkish (Turkey) (Chirp3-HD-Pulcherrima Female)',
  'tr-TR-Chirp3-HD-Rasalgethi' = 'Turkish (Turkey) (Chirp3-HD-Rasalgethi Male)',
  'tr-TR-Chirp3-HD-Sadachbia' = 'Turkish (Turkey) (Chirp3-HD-Sadachbia Male)',
  'tr-TR-Chirp3-HD-Sadaltager' = 'Turkish (Turkey) (Chirp3-HD-Sadaltager Male)',
  'tr-TR-Chirp3-HD-Schedar' = 'Turkish (Turkey) (Chirp3-HD-Schedar Male)',
  'tr-TR-Chirp3-HD-Sulafat' = 'Turkish (Turkey) (Chirp3-HD-Sulafat Female)',
  'tr-TR-Chirp3-HD-Umbriel' = 'Turkish (Turkey) (Chirp3-HD-Umbriel Male)',
  'tr-TR-Chirp3-HD-Vindemiatrix' = 'Turkish (Turkey) (Chirp3-HD-Vindemiatrix Female)',
  'tr-TR-Chirp3-HD-Zephyr' = 'Turkish (Turkey) (Chirp3-HD-Zephyr Female)',
  'tr-TR-Chirp3-HD-Zubenelgenubi' = 'Turkish (Turkey) (Chirp3-HD-Zubenelgenubi Male)',
  'tr-TR-Standard-A' = 'Turkish (Turkey) (Standard-A Female)',
  'tr-TR-Standard-B' = 'Turkish (Turkey) (Standard-B Male)',
  'tr-TR-Standard-C' = 'Turkish (Turkey) (Standard-C Female)',
  'tr-TR-Standard-D' = 'Turkish (Turkey) (Standard-D Female)',
  'tr-TR-Standard-E' = 'Turkish (Turkey) (Standard-E Male)',
  'tr-TR-Wavenet-A' = 'Turkish (Turkey) (Wavenet-A Female)',
  'tr-TR-Wavenet-B' = 'Turkish (Turkey) (Wavenet-B Male)',
  'tr-TR-Wavenet-C' = 'Turkish (Turkey) (Wavenet-C Female)',
  'tr-TR-Wavenet-D' = 'Turkish (Turkey) (Wavenet-D Female)',
  'tr-TR-Wavenet-E' = 'Turkish (Turkey) (Wavenet-E Male)',
  'uk-UA-Chirp3-HD-Achernar' = 'Ukrainian (Ukraine) (Chirp3-HD-Achernar Female)',
  'uk-UA-Chirp3-HD-Achird' = 'Ukrainian (Ukraine) (Chirp3-HD-Achird Male)',
  'uk-UA-Chirp3-HD-Algenib' = 'Ukrainian (Ukraine) (Chirp3-HD-Algenib Male)',
  'uk-UA-Chirp3-HD-Algieba' = 'Ukrainian (Ukraine) (Chirp3-HD-Algieba Male)',
  'uk-UA-Chirp3-HD-Alnilam' = 'Ukrainian (Ukraine) (Chirp3-HD-Alnilam Male)',
  'uk-UA-Chirp3-HD-Autonoe' = 'Ukrainian (Ukraine) (Chirp3-HD-Autonoe Female)',
  'uk-UA-Chirp3-HD-Callirrhoe' = 'Ukrainian (Ukraine) (Chirp3-HD-Callirrhoe Female)',
  'uk-UA-Chirp3-HD-Despina' = 'Ukrainian (Ukraine) (Chirp3-HD-Despina Female)',
  'uk-UA-Chirp3-HD-Enceladus' = 'Ukrainian (Ukraine) (Chirp3-HD-Enceladus Male)',
  'uk-UA-Chirp3-HD-Erinome' = 'Ukrainian (Ukraine) (Chirp3-HD-Erinome Female)',
  'uk-UA-Chirp3-HD-Gacrux' = 'Ukrainian (Ukraine) (Chirp3-HD-Gacrux Female)',
  'uk-UA-Chirp3-HD-Iapetus' = 'Ukrainian (Ukraine) (Chirp3-HD-Iapetus Male)',
  'uk-UA-Chirp3-HD-Laomedeia' = 'Ukrainian (Ukraine) (Chirp3-HD-Laomedeia Female)',
  'uk-UA-Chirp3-HD-Pulcherrima' = 'Ukrainian (Ukraine) (Chirp3-HD-Pulcherrima Female)',
  'uk-UA-Chirp3-HD-Rasalgethi' = 'Ukrainian (Ukraine) (Chirp3-HD-Rasalgethi Male)',
  'uk-UA-Chirp3-HD-Sadachbia' = 'Ukrainian (Ukraine) (Chirp3-HD-Sadachbia Male)',
  'uk-UA-Chirp3-HD-Sadaltager' = 'Ukrainian (Ukraine) (Chirp3-HD-Sadaltager Male)',
  'uk-UA-Chirp3-HD-Schedar' = 'Ukrainian (Ukraine) (Chirp3-HD-Schedar Male)',
  'uk-UA-Chirp3-HD-Sulafat' = 'Ukrainian (Ukraine) (Chirp3-HD-Sulafat Female)',
  'uk-UA-Chirp3-HD-Umbriel' = 'Ukrainian (Ukraine) (Chirp3-HD-Umbriel Male)',
  'uk-UA-Chirp3-HD-Vindemiatrix' = 'Ukrainian (Ukraine) (Chirp3-HD-Vindemiatrix Female)',
  'uk-UA-Chirp3-HD-Zubenelgenubi' = 'Ukrainian (Ukraine) (Chirp3-HD-Zubenelgenubi Male)',
  'uk-UA-Standard-B' = 'Ukrainian (Ukraine) (Standard-B Female)',
  'uk-UA-Wavenet-B' = 'Ukrainian (Ukraine) (Wavenet-B Female)',
  'ur-IN-Chirp3-HD-Achernar' = 'Urdu (India) (Chirp3-HD-Achernar Female)',
  'ur-IN-Chirp3-HD-Achird' = 'Urdu (India) (Chirp3-HD-Achird Male)',
  'ur-IN-Chirp3-HD-Algenib' = 'Urdu (India) (Chirp3-HD-Algenib Male)',
  'ur-IN-Chirp3-HD-Algieba' = 'Urdu (India) (Chirp3-HD-Algieba Male)',
  'ur-IN-Chirp3-HD-Alnilam' = 'Urdu (India) (Chirp3-HD-Alnilam Male)',
  'ur-IN-Chirp3-HD-Autonoe' = 'Urdu (India) (Chirp3-HD-Autonoe Female)',
  'ur-IN-Chirp3-HD-Callirrhoe' = 'Urdu (India) (Chirp3-HD-Callirrhoe Female)',
  'ur-IN-Chirp3-HD-Despina' = 'Urdu (India) (Chirp3-HD-Despina Female)',
  'ur-IN-Chirp3-HD-Enceladus' = 'Urdu (India) (Chirp3-HD-Enceladus Male)',
  'ur-IN-Chirp3-HD-Erinome' = 'Urdu (India) (Chirp3-HD-Erinome Female)',
  'ur-IN-Chirp3-HD-Gacrux' = 'Urdu (India) (Chirp3-HD-Gacrux Female)',
  'ur-IN-Chirp3-HD-Iapetus' = 'Urdu (India) (Chirp3-HD-Iapetus Male)',
  'ur-IN-Chirp3-HD-Laomedeia' = 'Urdu (India) (Chirp3-HD-Laomedeia Female)',
  'ur-IN-Chirp3-HD-Pulcherrima' = 'Urdu (India) (Chirp3-HD-Pulcherrima Female)',
  'ur-IN-Chirp3-HD-Rasalgethi' = 'Urdu (India) (Chirp3-HD-Rasalgethi Male)',
  'ur-IN-Chirp3-HD-Sadachbia' = 'Urdu (India) (Chirp3-HD-Sadachbia Male)',
  'ur-IN-Chirp3-HD-Sadaltager' = 'Urdu (India) (Chirp3-HD-Sadaltager Male)',
  'ur-IN-Chirp3-HD-Schedar' = 'Urdu (India) (Chirp3-HD-Schedar Male)',
  'ur-IN-Chirp3-HD-Sulafat' = 'Urdu (India) (Chirp3-HD-Sulafat Female)',
  'ur-IN-Chirp3-HD-Umbriel' = 'Urdu (India) (Chirp3-HD-Umbriel Male)',
  'ur-IN-Chirp3-HD-Vindemiatrix' = 'Urdu (India) (Chirp3-HD-Vindemiatrix Female)',
  'ur-IN-Chirp3-HD-Zubenelgenubi' = 'Urdu (India) (Chirp3-HD-Zubenelgenubi Male)',
  'ur-IN-Standard-A' = 'Urdu (India) (Standard-A Female)',
  'ur-IN-Standard-B' = 'Urdu (India) (Standard-B Male)',
  'ur-IN-Wavenet-A' = 'Urdu (India) (Wavenet-A Female)',
  'ur-IN-Wavenet-B' = 'Urdu (India) (Wavenet-B Male)',
  'vi-VN-Chirp3-HD-Achernar' = 'Vietnamese (Vietnam) (Chirp3-HD-Achernar Female)',
  'vi-VN-Chirp3-HD-Achird' = 'Vietnamese (Vietnam) (Chirp3-HD-Achird Male)',
  'vi-VN-Chirp3-HD-Algenib' = 'Vietnamese (Vietnam) (Chirp3-HD-Algenib Male)',
  'vi-VN-Chirp3-HD-Algieba' = 'Vietnamese (Vietnam) (Chirp3-HD-Algieba Male)',
  'vi-VN-Chirp3-HD-Alnilam' = 'Vietnamese (Vietnam) (Chirp3-HD-Alnilam Male)',
  'vi-VN-Chirp3-HD-Aoede' = 'Vietnamese (Vietnam) (Chirp3-HD-Aoede Female)',
  'vi-VN-Chirp3-HD-Autonoe' = 'Vietnamese (Vietnam) (Chirp3-HD-Autonoe Female)',
  'vi-VN-Chirp3-HD-Callirrhoe' = 'Vietnamese (Vietnam) (Chirp3-HD-Callirrhoe Female)',
  'vi-VN-Chirp3-HD-Charon' = 'Vietnamese (Vietnam) (Chirp3-HD-Charon Male)',
  'vi-VN-Chirp3-HD-Despina' = 'Vietnamese (Vietnam) (Chirp3-HD-Despina Female)',
  'vi-VN-Chirp3-HD-Enceladus' = 'Vietnamese (Vietnam) (Chirp3-HD-Enceladus Male)',
  'vi-VN-Chirp3-HD-Erinome' = 'Vietnamese (Vietnam) (Chirp3-HD-Erinome Female)',
  'vi-VN-Chirp3-HD-Fenrir' = 'Vietnamese (Vietnam) (Chirp3-HD-Fenrir Male)',
  'vi-VN-Chirp3-HD-Gacrux' = 'Vietnamese (Vietnam) (Chirp3-HD-Gacrux Female)',
  'vi-VN-Chirp3-HD-Iapetus' = 'Vietnamese (Vietnam) (Chirp3-HD-Iapetus Male)',
  'vi-VN-Chirp3-HD-Kore' = 'Vietnamese (Vietnam) (Chirp3-HD-Kore Female)',
  'vi-VN-Chirp3-HD-Laomedeia' = 'Vietnamese (Vietnam) (Chirp3-HD-Laomedeia Female)',
  'vi-VN-Chirp3-HD-Leda' = 'Vietnamese (Vietnam) (Chirp3-HD-Leda Female)',
  'vi-VN-Chirp3-HD-Orus' = 'Vietnamese (Vietnam) (Chirp3-HD-Orus Male)',
  'vi-VN-Chirp3-HD-Puck' = 'Vietnamese (Vietnam) (Chirp3-HD-Puck Male)',
  'vi-VN-Chirp3-HD-Pulcherrima' = 'Vietnamese (Vietnam) (Chirp3-HD-Pulcherrima Female)',
  'vi-VN-Chirp3-HD-Rasalgethi' = 'Vietnamese (Vietnam) (Chirp3-HD-Rasalgethi Male)',
  'vi-VN-Chirp3-HD-Sadachbia' = 'Vietnamese (Vietnam) (Chirp3-HD-Sadachbia Male)',
  'vi-VN-Chirp3-HD-Sadaltager' = 'Vietnamese (Vietnam) (Chirp3-HD-Sadaltager Male)',
  'vi-VN-Chirp3-HD-Schedar' = 'Vietnamese (Vietnam) (Chirp3-HD-Schedar Male)',
  'vi-VN-Chirp3-HD-Sulafat' = 'Vietnamese (Vietnam) (Chirp3-HD-Sulafat Female)',
  'vi-VN-Chirp3-HD-Umbriel' = 'Vietnamese (Vietnam) (Chirp3-HD-Umbriel Male)',
  'vi-VN-Chirp3-HD-Vindemiatrix' = 'Vietnamese (Vietnam) (Chirp3-HD-Vindemiatrix Female)',
  'vi-VN-Chirp3-HD-Zephyr' = 'Vietnamese (Vietnam) (Chirp3-HD-Zephyr Female)',
  'vi-VN-Chirp3-HD-Zubenelgenubi' = 'Vietnamese (Vietnam) (Chirp3-HD-Zubenelgenubi Male)',
  'vi-VN-Neural2-A' = 'Vietnamese (Vietnam) (Neural2-A Female)',
  'vi-VN-Neural2-D' = 'Vietnamese (Vietnam) (Neural2-D Male)',
  'vi-VN-Standard-A' = 'Vietnamese (Vietnam) (Standard-A Female)',
  'vi-VN-Standard-B' = 'Vietnamese (Vietnam) (Standard-B Male)',
  'vi-VN-Standard-C' = 'Vietnamese (Vietnam) (Standard-C Female)',
  'vi-VN-Standard-D' = 'Vietnamese (Vietnam) (Standard-D Male)',
  'vi-VN-Wavenet-A' = 'Vietnamese (Vietnam) (Wavenet-A Female)',
  'vi-VN-Wavenet-B' = 'Vietnamese (Vietnam) (Wavenet-B Male)',
  'vi-VN-Wavenet-C' = 'Vietnamese (Vietnam) (Wavenet-C Female)',
  'vi-VN-Wavenet-D' = 'Vietnamese (Vietnam) (Wavenet-D Male)'
}

export enum GoogleTTSEncoding {
  'LINEAR16' = 'Linear 16',
  'MP3' = 'MP3',
  'OGG_OPUS' = 'OGG Opus',
  'MULAW' = 'MULAW',
  'PCM' = 'PCM',
}